import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import $ from "jquery";
import html2pdf from "html2pdf.js";
import SignatureCanvas from "react-signature-canvas";
import { db, auth, storage } from "../firebase/firebase";
import {
    collection,
    addDoc,
    serverTimestamp,
    count,
    getDocs,
    setDoc,
    doc,
    getDoc,
    updateDoc,
    query, where,
} from "firebase/firestore";
import generateId from "../../utils/helpers/appId";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import { toast } from "react-toastify";
import axios from "axios"; // For making HTTP requests
import { format, parseISO } from "date-fns"; // For date parsing and formatting
import "./bookappointment.css";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { Spinner } from "react-bootstrap";

const RadioButton = ({ id, name, label, checked, onChange }) => (
    <div className="form-check ">
        <input
            className="form-check-input"
            type="radio"
            name={name}
            id={id}
            checked={checked}
            onChange={onChange}
        />
        <label
            className="form-check-label"
            htmlFor={id}
            style={{ cursor: "pointer" }}
        >
            {label}
        </label>
    </div>
);

// Reusable Checkbox Component
const Checkbox = ({ id, label, checked, onChange, key, className }) => (
    <div className={`form-check ${className}`} key={key}>
        <input
            className="form-check-input"
            type="checkbox"
            id={id}
            checked={checked}
            onChange={onChange}
        />
        <label
            className="form-check-label"
            htmlFor={id}
            style={{ cursor: "pointer" }}
        >
            {label}
        </label>
    </div>
);

const BookAppointment = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [columnCounts, setColumnCounts] = useState([0, 0, 0, 0]); // Track counts for each column
    const [columnGadCounters, setcolumnGadCounters] = useState([0, 0, 0, 0]); // Track counts for each column
    const [mainTextArea, setMainTextArea] = useState("");
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Please fill all details.");
    const [scores, setScores] = useState({});
    const [gadScores, setgadScores] = useState({});

    const [formData, setFormData] = useState({
        firstform_depressesed: '',
        firstform_mentalhealth: '',
        mentalHealthDetails: { name: '', dosage: '', frequency: '' },
        firstform_psychiatric: '',
        medicalHistory: '',
        presentIllnessRadio: "",
        moodRadio: "",
        anxietyRadio: "",
        panicRadio: "",
        phobiaRadio: "",
        socialanxietyRadio: "",
        maniacsymptonsRadio: "",
        adhdRadio: "",
        self_injuryRadio: "",
        obsessiveBehavioursRadio: "",
        eatingIssuesRadio: "",
        traumaSymptonsRadio: "",
        realitySymptonsRadio: "",
        safetyConcernsRadio: "",
        substanceUseDifficultyRadio: "",
        neurocognitiveSymtponsRadio: "",
        pastHistoryOptionsRadio: true,
        medicalHistoryOptionsRadio: true,
        neurologicHistoryOptionsRadio: "",
        birthControlOptionsRadio: true,
        medicationsRadio: "",
        familyRelationshipOptions1Radio: true,
        socialRelationshipOptionsRadio: true,
        genderRadio: true,
        satisfactionSexRadio: true,
        interestRadio: true,
        livingSituationsRadio: true,
        workEducationOptionsRadio: true,
        relationshipStatusOptionsRadio: true,
        academicPerformanceRadio: "",
        academicExperienceRadio: "",
        academicExperienceOptionsRadio: "",
        academicInterventionRadio: "",
        workPerformanceOptionsRadio: "",

        presentIllness: [],
        mood: [],
        anxiety: [],
        panic: [],
        phobia: [],
        socialanxiety: [],
        maniacsymptons: [],
        adhd: [],
        self_injury: [],
        obsessiveBehaviours: [],
        eatingIssues: [],
        traumaSymptons: [],
        realitySymptons: [],
        safetyConcerns: [],
        substanceUseDifficulty: [],
        neurocognitiveSymtpons: [],
        pastHistoryOptions: [],
        medicalHistoryOptions: [],
        neurologicHistoryOptions: [],
        birthControlOptions: [],
        familyRelationshipOptions1: [],
        socialRelationshipOptions: [],
        gender: [],
        satisfactionSex: [],
        interest: [],
        livingSituations: [],
        workEducationOptions: [],
        relationshipStatusOptions: [],
        academicPerformance: [],
        academicExperience: "true",
        academicExperienceOptions: [],
        academicIntervention: [],
        workPerformanceOptions: [],
        workExperienceOptions: [],
    });
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [date, setDate] = useState("");
    const [dob, setDob] = useState("");
    const [countryCode, setCountryCode] = useState("");
    const [phone, setPhone] = useState("");
    const [userGender, setUserGender] = useState("");
    const [description, setDescription] = useState("");
    const [time, setTime] = useState("");
    const [firstFormError, setFirstFormError] = useState(false)
    const [appId, setAppID] = useState("")
    const [slots, setSlots] = useState([]);
    const [currentDay, setCurrentDay] = useState("monday");
    const [selectedDate, setSelectedDate] = useState(""); // Stores the selected appointment date
    const [selectedTime, setSelectedTime] = useState(""); // Stores the chosen time slot
    const [allTimeSlots, setAllTimeSlots] = useState({}); // Stores all time slots from Firestore
    const [isLoading, setIsLoading] = useState(false); // Indicates if data is being loaded
    const [daySpecificSlots, setDaySpecificSlots] = useState([]); // Slots for the selected day
    const [selectedSlot, setSelectedSlot] = useState(null); // Track selected time slot
    const [enableForms, setEnableForms] = useState(); // Track selected time slot
    const [signatureValid, setSignatureValid] = useState(true);
    const modalContentRef = useRef(null);
    // const [mainForm, setMainForm] = useState({presentIllness:"",presentIllnessOption:[]});
    const [textAreaData, setTextAreaData] = useState({
        mentalHistoryOptionRadio: "",
        psychotherapeuticTreatmentRadio: "",
        otcMedicationOptionRadio: "",
        familyMedicalOptionsRadio: "",
        familyHistoryOptionsRadio: "",
        mentalHistoryOption: {
            "mental-health-depressive-episodes": "",
            "mental-health-manic-episodes": "",
            "mental-health-psychotic-episodes": "",
            "mental-health-self-injurious": "",
            "mental-health-anxiety": "",
            "mental-health-eating-issues": "",
            "mental-health-trauma-issues": "",
            "mental-health-relationship-issues": "",
            "mental-health-other-issues": "",
        },
        psychotherapeuticTreatment: {
            "treatment-individual-psychotherapy": "",
            "treatment-family-psychotherapy": "",
            "treatment-group-psychotherapy": "",
            "treatment-social-skills": "",
            "treatment-anger-management": "",
            "treatment-intensive-outpatient": "",
            "treatment-partial-hospitalization": "",
            "treatment-hospitalization": "",
        },
        otcMedicationOption: {
            "prescribed-med-1": "",
            "prescribed-med-": "",
            "prescribed-med-3": "",
            "prescribed-med-4": "",
            "prescribed-med-5": "",
            "prescribed-med-6": "",
            "prescribed-med-7": "",
            "otc-med-1": "",
            "otc-med-2": "",
            "otc-med-3": "",
            "herbal-med-1": "",
            "herbal-med-2": "",
            "herbal-med-3": "",
            "alternative-med-1": "",
            "alternative-med-2": "",
            "alternative-med-3": "",
        },
        familyHistoryOptions: {
            "family-history-mother": "",
            "family-history-grandmother": "",
            "family-history-grandfather": "",
            "family-history-aunt": "",
            "family-history-cousin": "",
            "family-history-father": "",
            "family-history-sister": "",
            "family-history-brother": "",
            "family-history-daughter": "",
            "family-history-son": "",
        },
        familyMedicalOptions: {
            "family-medical-mother": "",
            "family-medical-grandmother": "",
            "family-medical-grandfather": "",
            "family-medical-uncle": "",
            "family-medical-aunt": "",
            "family-medical-cousin": "",
            "family-medical-father": "",
            "family-medical-sister": "",
            "family-medical-brother": "",
            "family-medical-daughter": "",
            "family-medical-son": "",
        },
    });

    async function fetchFormEnable() {
        try {
            const docRef = doc(db, "questionEnable", "selectedOptions");
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                setEnableForms(docSnap.data());
            } else {
                console.log("No such document!");
            }
        } catch (error) {
            console.error("Error writing document: ", error);
        }
    }
    const stepCount = 3;
    const pdf2 =
        "/assets/pdf/Preview intake questionnaire - WITCARE HEALTH.pdf";
    const progressWidth = (100 / (stepCount - 1)) * currentStep;
    const navigate = useNavigate();

    //refs

    const moodSectionRef = useRef(null);
    const anxietySectionRef = useRef(null);
    const textareaRef = useRef(null);
    const controlRef = useRef(null);
    const [dialcode, setDialcode] = useState();
    let iti = null;

    const phqQuestions = [
        {
            id: 1,
            text: "Little interest or pleasure in doing things.",
            name: "phq1",
        },
        { id: 2, text: "Feeling down, depressed, or hopeless.", name: "phq2" },
        {
            id: 3,
            text: "Trouble falling or staying asleep, or sleeping too much.",
            name: "phq3",
        },
        { id: 4, text: "Feeling tired or having little energy.", name: "phq4" },
        { id: 5, text: "Poor appetite or overeating.", name: "phq5" },
        {
            id: 6,
            text: "Feeling bad about yourself – or that you are a failure or have let yourself or your family down.",
            name: "phq6",
        },
        {
            id: 7,
            text: "Trouble concentrating on things, such as reading newspaper or watching television..",
            name: "phq7",
        },
        {
            id: 8,
            text: "Moving or speaking so slowly that other people could have noticed. Or the opposite – being so fidgety or restless that you have been moving around a lot more than usual.",
            name: "phq8",
        },
        {
            id: 9,
            text: "Thoughts that you would be better off dead, or of hurting yourself in some way.",
            name: "phq9",
        },
        { id: 10, text: "The score for each column", name: "eachColumnScore" },
        { id: 11, text: "Total Score", name: "phqtotalScore" },
    ];

    // const gad7Questions = [
    //     { id: "gad_1", text: "Feeling nervous, anxious, or on edge.", name: "gad1" },
    //     {
    //         id: "gad_2",
    //         text: "Not being able to stop or control worrying.",
    //         name: "gad2",
    //     },
    //     {
    //         id: "gad_3",
    //         text: "Worrying too much about different things.",
    //         name: "gad3",
    //     },
    //     { id: "gad_4", text: "Trouble relaxing.", name: "gad4" },
    //     {
    //         id: "gad_5",
    //         text: "Being so restless that it’s hard to sit still.",
    //         name: "gad5",
    //     },
    //     { id: "gad_6", text: "Becoming easily annoyed or irritable.", name: "gad6" },
    //     {
    //         id: "gad_7",
    //         text: "Feeling afraid as if something awful might happen.",
    //         name: "gad7",
    //     },
    //     { id: "gad_8", text: "The score for each column", name: "gadEachColumnScore" },
    //     { id: "gad_9", text: "Total Score", name: "gadEachColumnScore" },
    // ];
    const gad7Questions = [
        { id: 1, text: "Feeling nervous, anxious, or on edge.", name: "gad1" },
        {
            id: 2,
            text: "Not being able to stop or control worrying.",
            name: "gad2",
        },
        {
            id: 3,
            text: "Worrying too much about different things.",
            name: "gad3",
        },
        { id: 4, text: "Trouble relaxing.", name: "gad4" },
        {
            id: 5,
            text: "Being so restless that it’s hard to sit still.",
            name: "gad5",
        },
        { id: 6, text: "Becoming easily annoyed or irritable.", name: "gad6" },
        {
            id: 7,
            text: "Feeling afraid as if something awful might happen.",
            name: "gad7",
        },
        { id: 8, text: "The score for each column", name: "gadEachColumnScore" },
        { id: 9, text: "Total Score", name: "gadEachColumnScore" },
    ];

    useEffect(() => {
        modalContentRef.current.scrollIntoView({ behavior: "smooth" });
    }, [currentStep]);

    const options1 = [
        { id: "relationships", label: "Relationships" },
        { id: "finances", label: "Finances" },
        { id: "job", label: "Job" },
        { id: "academics", label: "Academics" },
        { id: "family", label: "Family" },
        { id: "housing", label: "Housing" },
    ];

    const moodOptions = [
        // { id: "palpitations", label: "Palpitations" },
        // { id: "motivation", label: "Sweating" },
        { id: "irritability", label: "Irritability" },
        { id: "hopelessness", label: "Hopelessness" },
        { id: "guilt", label: "Guilt" },
        { id: "low-self-esteem", label: "Low self-esteem" },
        { id: "change-in-sleep", label: "Change in sleep" },
        { id: "diminished-energy", label: "Diminished energy" },
        { id: "change-in-appetite", label: "Change in appetite" },
        { id: "change-in-weight", label: "Change in weight" },
        { id: "diminished-focus", label: "Diminished focus" },
        { id: "change-in-sex-drive", label: "Change in sex drive" },
        { id: "physically-restless", label: "Feeling physically restless" },
        { id: "suicidal-thinking", label: "Suicidal thinking" },
    ];

    const anxietyOptions = [
        { id: "edginess", label: "Edginess or restlessness" },
        { id: "fatigue", label: "Fatigue" },
        { id: "poor-focus", label: "Poor focus" },
        { id: "irritability-anxiety", label: "Irritability" },
        { id: "muscle-aches", label: "Increased muscle aches or soreness" },
        { id: "poor-sleep", label: "Poor sleep" },
        { id: "anxiety-interfere", label: "Symptoms above interfere with overall functioning" }
    ];

    const panicOptions = [
        { id: "Palpitations", label: "Palpitations" },
        { id: "Sweating", label: "Sweating" },
        { id: "shaking", label: "Shaking" },
        { id: "Shortness of breath", label: "Shortness of breath" },
        { id: "Choking", label: "Choking" },
        { id: "chest-pain/discomfort", label: "Chest pain/discomfort" },
        {
            id: "Nausea-or-abdominaldistress",
            label: "Nausea or abdominal distress",
        },
        { id: "Dizziness", label: "Dizziness" },
        {
            id: "Derealization-or-depersonalization",
            label: "Derealization or depersonalization",
        },
        { id: "Fear-of-losing", label: "Fear of losing control or going crazy" },
        { id: "Fear-of-dying", label: "Fear of dying" },
        { id: "changes-in-sex-drive", label: "Change in sex drive" },
        { id: "Paresthesias", label: "Paresthesias" },
        { id: "Chills-or-hotflushes", label: "Chills or hot flushes" },
        {
            id: "Symptoms-above-interfere",
            label: "Symptoms above interfere with overall functioning",
        },
    ];

    const phobiaOptions = [
        { id: "fear", label: "Fear is excessive" },
        { id: "anxiety", label: "Immediate anxiety response" },
        { id: "distress", label: "Avoid or endure with distress" },
        { id: "interferes-functioning", label: "Interferes with functioning" },
    ];

    const socialAnxietyOptions = [
        { id: "fear-embarrassment", label: "Persistent fear of embarrassment" },
        { id: "high-anxiety", label: "Exposure provokes high anxiety" },
        {
            id: "avoid-social-situations",
            label: "Avoid social situations or endure with great distress",
        },
        {
            id: "interferes-functioning1",
            label: "Symptoms above interfere with overall functioning",
        },
    ];

    const maniacOptions = [
        { id: "elevated-mood", label: "Elevated/euphoric mood" },
        { id: "irritable-mood", label: "Irritable/angry mood" },
        { id: "need-sleep", label: "Decreased need for sleep" },
        { id: "feeling-superior", label: "Feeling superior" },
        { id: "more-sexual", label: "More sexual than usual" },
        { id: "overtalkative", label: "Overtalkative" },
        { id: "racing-thoughts", label: "Racing thoughts" },
        { id: "distractible", label: "Distractible" },
        { id: "reckless", label: "Reckless" },
        { id: "impulsive", label: "Impulsive" },
        {
            id: "manic-lately-interfere",
            label: "Symptoms above interfere with overall functioning",
        },
    ];

    const adhdOptions = [
        { id: "trouble-finishing-projects", label: "Trouble finishing projects" },
        { id: "organizational-difficulty", label: "Organizational difficulty" },
        {
            id: "remembering-obligations",
            label: "Problems with remembering obligations",
        },
        { id: "procrastination", label: "Procrastination" },
        { id: "fidgety", label: "Fidgety when you have to sit for a long time" },
        { id: "feeling-overly-active", label: "Feeling overly active" },
        { id: "careless-mistakes", label: "Make careless mistakes" },
        { id: "difficulty-attention", label: "Difficulty paying attention" },
        {
            id: "difficulty-concentrating",
            label: "Difficulty concentrating when others are talking to you",
        },
        { id: "misplace-things", label: "Misplace things" },
        { id: "adhd-distractible", label: "Distractible" },
        { id: "adhd-meetings", label: "Get up during meetings" },
        { id: "restless-fidgety", label: "Restless or fidgety" },
        { id: "adhd-relaxing", label: "Difficulty relaxing" },
        { id: "adhd-talking", label: "Talk too much" },
        { id: "adhd-sentences", label: "Finish sentences for others" },
        { id: "adhd-turn", label: "Difficulty waiting your turn" },
        { id: "interrupt-others", label: "Interrupt others when they are busy" },
    ];

    const selfInjuriousBehaviors = [
        { id: "self-injurious-biting", label: "Biting" },
        { id: "self-injurious-picking", label: "Picking" },
        { id: "self-injurious-plucking", label: "Plucking" },
        { id: "self-injurious-pulling", label: "Pulling" },
        { id: "self-injurious-cutting", label: "Cutting" },
        { id: "self-injurious-scratching", label: "Scratching" },
        {
            id: "self-injurious-interfere",
            label: "Symptoms above interfere with overall functioning",
        },
    ];

    const obsessiveCompulsiveBehaviors = [
        {
            id: "obsessive-intrusive",
            label: "Intrusive, recurrent thoughts, urges, or impulses",
        },
        {
            id: "obsessive-attempts",
            label: "Attempts to ignore or suppress obsessions",
        },
        {
            id: "obsessive-mental",
            label: "Driven to perform repetitive behaviors or mental acts",
        },
        { id: "obsessive-excessive", label: "Behaviors are excessive" },
        {
            id: "obsessive-interfere",
            label:
                "Symptoms above are time consuming or cause distress or interfere with overall functioning",
        },
    ];

    const eatingIssues = [
        { id: "eating-issues-restriction", label: "Food restriction" },
        {
            id: "eating-issues-gaining-weight",
            label: "Intense fear of gaining weight or becoming fat",
        },
        { id: "eating-issues-body-image", label: "Not happy with body image" },
        { id: "eating-issues-binge", label: "Binge eating" },
        {
            id: "eating-issues-lackof-control",
            label: "Lack of control while binging",
        },
        {
            id: "eating-issues-lose-weight",
            label: "Compensatory behaviors to lose weight",
        },
        {
            id: "eating-issues-significant-loseweight",
            label: "Significant weight loss lately",
        },
    ];

    const traumaSymptomsOptions = [
        { id: "trauma-exposure", label: "Direct exposure to trauma" },
        { id: "trauma-witnessing", label: "Witnessing trauma" },
        { id: "trauma-nightmares", label: "Nightmares" },
        { id: "trauma-flashbacks", label: "Flashbacks" },
        { id: "trauma-emotional", label: "Emotional distress after reminders" },
        { id: "trauma-physical", label: "Physical reactivity after reminders" },
        { id: "trauma-thoughts", label: "Trauma-related thoughts or feelings" },
        { id: "trauma-reminders", label: "Trauma-related reminders" },
        { id: "trauma-inability", label: "Inability to recall key features" },
        { id: "trauma-negative-thoughts", label: "Overly negative thoughts" },
        { id: "trauma-exaggerated", label: "Exaggerated blame" },
        { id: "trauma-negative-affect", label: "Negative affect" },
        { id: "trauma-low-motivation", label: "Low motivation" },
        { id: "trauma-isolated", label: "Feeling isolated" },
        { id: "trauma-aggression", label: "Irritability or aggression" },
        {
            id: "trauma-destructive-behavior",
            label: "Risky or destructive behavior",
        },
        { id: "trauma-hypervigilance", label: "Hypervigilance" },
        { id: "trauma-heightened", label: "Heightened startle reaction" },
        { id: "trauma-concentrating", label: "Difficulty concentrating" },
        { id: "trauma-sleeping", label: "Difficulty sleeping" },
        {
            id: "trauma-overall",
            label: "Symptoms above interfere with overall functioning",
        },
    ];

    const realitySymptomsOptions = [
        { id: "reality-hearing", label: "Hearing things others don't hear" },
        { id: "reality-seeing", label: "Seeing things others don't see" },
        { id: "reality-skin-sensations", label: "Unusual skin sensations" },
        { id: "reality-smells", label: "Unusual smells" },
        { id: "reality-touch", label: "Feeling out of touch with reality" },
        { id: "reality-body", label: "Feeling out of your body" },
        { id: "reality-putting", label: "People putting thoughts in your head" },
        { id: "reality-taking", label: "People taking thoughts out of your head" },
        { id: "reality-thoughts", label: "Others can read your thoughts" },
        {
            id: "reality-computer",
            label: "TV, radio, computer is talking to/about you",
        },
        {
            id: "reality-overall",
            label: "Symptoms above interfere with overall functioning",
        },
    ];

    const safetyConcernsOptions = [
        { id: "safety-alive", label: "Thoughts of not wanting to be alive" },
        { id: "safety-harming", label: "Self-harming behavior" },
        { id: "safety-ideation", label: "Suicidal ideation" },
        { id: "safety-planning", label: "Suicidal planning" },
        { id: "safety-attempts", label: "Suicide attempts" },
    ];

    const substanceUseDifficulty = [
        { id: "substance-more-longer", label: "Using more/longer than prescribed" },
        { id: "substance-cut-down", label: "Can't cut down" },
        { id: "substance-time-consuming", label: "Time-consuming" },
        { id: "substance-cravings", label: "Cravings" },
        { id: "substance-home-work", label: "Negatively affects home/work" },
        { id: "substance-relationship-problems", label: "Relationship problems" },
        { id: "substance-social-life", label: "Negatively affects social life" },
        { id: "substance-known-danger", label: "Use despite known danger" },
        {
            id: "substance-physical-emotional",
            label: "Use despite known physical/emotional effects",
        },
        { id: "substance-tolerance", label: "Tolerance" },
        { id: "substance-withdrawal", label: "Withdrawal" },
    ];

    const neurocognitiveSymtpons = [
        { id: "neurocognitive-attention", label: "Impaired attention" },
        { id: "neurocognitive-planning", label: "Impaired planning" },
        {
            id: "neurocognitive-learning-memory",
            label: "Impaired learning and memory",
        },
        {
            id: "neurocognitive-visual-spatial",
            label: "Impairment in visual and spatial coordination",
        },
        {
            id: "neurocognitive-social-nuance",
            label: "Struggling with social nuance",
        },
        { id: "neurocognitive-personality", label: "Changes in personality" },
        { id: "neurocognitive-behavior", label: "Changes in behavior" },
    ];

    const pastHistoryOptions = [
        { id: "past-history-prenatal", label: "Pre-natal" },
        { id: "past-history-birth", label: "Birth" },
        { id: "past-history-c-section", label: "Birth (via c-section)" },
        { id: "past-history-natal", label: "Post-natal course" },
        { id: "past-history-bonding", label: "Bonding" },
        { id: "past-history-feeding", label: "Feeding" },
        { id: "past-history-elimination", label: "Elimination" },
        { id: "past-history-gross-motor", label: "Gross motor" },
        { id: "past-history-fine-motor", label: "Fine motor" },
        { id: "past-history-social", label: "Social" },
        { id: "past-history-language", label: "Language" },
    ];

    const medicalHistoryOptions = [
        { id: "medical-history-asthma", label: "Asthma" },
        { id: "medical-history-cardiac", label: "Cardiac" },
        { id: "medical-history-cancer", label: "Cancer" },
        { id: "medical-history-diabetes", label: "Diabetes" },
        { id: "medical-history-illnesses", label: "Illnesses" },
        { id: "medical-history-injuries", label: "Injuries" },
        { id: "medical-history-surgeries", label: "Surgeries" },
    ];

    const neurologicHistoryOptions = [
        { id: "seizures", label: "Seizures" },
        { id: "head-trauma", label: "Head trauma" },
        { id: "loss-of-consciousness", label: "Loss of consciousness" },
        { id: "stroke", label: "Stroke" },
    ];

    const birthControlOptions = [
        {
            id: "birth-control-not-active",
            name: "birth-control-not-active",
            label: "Not sexually active",
        },
        {
            id: "birth-control-condom",
            name: "birth-control-condom",
            label: "Condom",
        },
        {
            id: "birth-control-diaphragm",
            name: "birth-control-diaphragm",
            label: "Diaphragm",
        },
        { id: "birth-control-iud", name: "birth-control-iud", label: "IUD" },
        {
            id: "birth-control-ocp",
            name: "birth-control-ocp",
            label: "OCP (Oral Contraceptive Pill)",
        },
        {
            id: "birth-control-injection",
            name: "birth-control-injection",
            label: "Injection",
        },
        { id: "birth-control-none", name: "birth-control-none", label: "None" },
    ];

    const familyRelationshipOptions = [
        { id: "Connected", label: "Connected" },
        { id: "Isolated", label: "Isolated" },
        { id: "Stressful1", label: "Stressful" },
        { id: "Mildly-stressful", label: "Mildly stressful" },
        { id: "Not-stressful", label: "Not stressful" },
        { id: "Other1", label: "Other" },
    ];

    const socialRelationshipOptions = [
        { id: "social_Connected", label: "Connected" },
        { id: "social_Isolated", label: "Isolated" },
        { id: "social_Stressful", label: "Stressful" },
        { id: "social_Mildly-stressful", label: "Mildly stressful" },
        { id: "social_Not-stressful", label: "Not stressful" },
        { id: "social_Other", label: "Other" },
    ];

    const gender = [
        { id: "content", label: "Content" },
        { id: "ambivalent", label: "Ambivalent" },
        { id: "displeased", label: "Displeased" },
    ];

    const satisfactionSex = [
        { id: "satisfic-not-sexually-active", label: "Not sexually active" },
        { id: "satisfic-enjoy", label: "Enjoyable" },
        { id: "satisfic-neutral", label: "Neutral" },
        { id: "satisfic-not-enjoy", label: "Not enjoyable" },
        { id: "satisfic-stress", label: "Stressful" },
        { id: "satisfic-mindly-stress", label: "Mildly stressful" },
        { id: "satisfic-not-stress", label: "Not stressful" },
        { id: "satisfic-other", label: "Other" },
    ];

    const interest = [
        { id: "interests-art", label: "Art" },
        { id: "interests-history", label: "History" },
        { id: "interests-politics", label: "Politics" },
        { id: "interests-reading", label: "Reading" },
        { id: "interests-science", label: "Science" },
        { id: "interests-sports", label: "Sports" },
        { id: "interests-videogames", label: "Videogames" },
        { id: "interests-none", label: "None" },
        { id: "interests-other", label: "Other" },
    ];

    const livingSituations = [
        {
            id: "living-alone",
            name: "living-situation",
            label: "Alone, independently",
        },
        {
            id: "living-roommates",
            name: "living-situation",
            label: "Roommate(s)/house-mate(s)",
        },
        {
            id: "living-family",
            name: "living-situation",
            label: "Family member(s)",
        },
        {
            id: "living-romantic-partner",
            name: "living-situation",
            label: "Romantic partner(s)",
        },
        { id: "living-homeless", name: "living-situation", label: "Homeless" },
        {
            id: "living-group-home",
            name: "living-situation",
            label: "Group home or other supported living situation",
        },
        { id: "living-other", name: "living-situation", label: "Other" },
    ];

    const workEducationOptions = [
        {
            id: "work-education-attending-school",
            label: "Attending school/college/other work or educational programming",
        },
        { id: "work-education-full-time", label: "Employed (full time)" },
        { id: "work-education-part-time", label: "Employed (part time)" },
        {
            id: "work-education-sporadically-employed",
            label: "Sporadically employed",
        },
        { id: "work-education-unemployed", label: "Unemployed" },
        { id: "work-education-disability", label: "On disability" },
        { id: "work-education-other", label: "Other" },
    ];

    const academicPerformanceOptions = [
        { id: "Excellent", label: "Excellent" },
        { id: "Good", label: "Good" },
        { id: "Fair", label: "Fair" },
        { id: "Poor", label: "Poor" },
        { id: "Other", label: "Other" },
    ];

    const academicExperienceOptions = [
        { id: "Enjoyable", label: "Enjoyable" },
        { id: "Neutral", label: "Neutral" },
        { id: "Not enjoyable", label: "Not enjoyable" },
        { id: "Stressful", label: "Stressful" },
        { id: "Mildly stressful", label: "Mildly stressful" },
        { id: "Not stressful", label: "Not stressful" },
    ];

    const academicInterventionOptions = [
        { id: "504-plan", label: "504 plan" },
        { id: "IEP", label: "IEP" },
        { id: "SST", label: "SST" },
        { id: "testing-accommodations", label: "Testing accommodations" },
        { id: "special-education-setting", label: "Special Education setting" },
        { id: "none", label: "None" },
        { id: "other", label: "Other" },
    ];

    const workPerformanceOptions = [
        { id: "Excellent2", label: "Excellent" },
        { id: "Good2", label: "Good" },
        { id: "Fair2", label: "Fair" },
        { id: "Poor2", label: "Poor" },
        { id: "Other2", label: "Other" },
    ];

    const workExperienceOptions = [
        { id: "Enjoyable2", label: "Enjoyable" },
        { id: "Neutral2", label: "Neutral" },
        { id: "Not enjoyable2", label: "Not enjoyable" },
        { id: "Stressful2", label: "Stressful" },
        { id: "Mildly stressful2", label: "Mildly stressful" },
        { id: "Not stressful2", label: "Not stressful" },
    ];

    const relationshipStatusOptions = [
        { id: "relationship-single", label: "Single" },
        { id: "relationship-dating", label: "Dating" },
        { id: "relationship-long-term", label: "In a long-term partnership" },
        { id: "relationship-married", label: "Married" },
        { id: "relationship-separated", label: "Separated" },
        { id: "relationship-divorced", label: "Divorced" },
    ];

    // const handleNext = async ( ) => {
    //     if (currentStep < stepCount - 1) {
    //         setCurrentStep((prev) => prev + 1);
    //         if (currentStep == 1) {

    //             if(columnGadCounters == "0"){
    //                 Swal.fire({
    //                     title: "Form is not filled.",
    //                     text: "Please fill the form before procedding to next step!",
    //                     icon: "warning"
    //                   });
    //                   return false
    //                 // Swal.fire
    //             }

    //             console.log(columnGadCounters)
    //             const formElement = document.querySelector('.last_form'); // Select the form container

    //             // Options for the PDF
    //             const options = {
    //                 margin: 0.5,
    //                 filename: 'form-data.pdf',
    //                 image: { type: 'jpeg', quality: 0.98 },
    //                 html2canvas: { scale: 2 },
    //                 jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    //             };

    //             html2pdf()
    //                 .from(formElement) // Convert the selected element to PDF
    //                 .set(options) // Apply options
    //                 .save() // Save the PDF
    //                 .then(() => {
    //                     alert('PDF saved successfully!');
    //                     handleNext(); // Move to the next step
    //                 })
    //                 .catch((error) => {
    //                     console.error('Error generating PDF:', error);
    //                     alert('An error occurred while generating the PDF');
    //                 });
    //         }
    //     }

    // };

    //             html2pdf()
    //                 .from(formElement) // Convert the selected element to PDF
    //                 .set(options) // Apply options
    //                 .save() // Save the PDF
    //                 .then(() => {
    //                     alert('PDF saved successfully!');
    //                     handleNext(); // Move to the next step
    //                 })
    //                 .catch((error) => {
    //                     console.error('Error generating PDF:', error);
    //                     alert('An error occurred while generating the PDF');
    //                 });
    //         }
    //     }
    // };

    const handleCheckboxChange1 = (event, category) => {
        const { id, checked } = event.target;

        setFormData((prevData) => {
            // Ensure prevData[category] is always an array
            const currentSymptoms = Array.isArray(prevData[category])
                ? prevData[category]
                : [];

            const updatedSymptoms = checked
                ? [...currentSymptoms, id] // Add id if checked
                : currentSymptoms.filter((item) => item !== id); // Remove id if unchecked

            return { ...prevData, [category]: updatedSymptoms }; // Update state
        });
    };

    const handleRadioChange = (event, category) => {
        const { id } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [category]: id, // Store only the selected radio button's ID
        }));
    };

    const handleFirstFormRadioChange = (e, question) => {
        const { value } = e.target;

        setFormData(prevState => ({
            ...prevState,
            [question]: value, // Update the state for the radio button
        }));
    };


    useEffect(() => {
        const storedData = localStorage.getItem("appointmentData");
        if (storedData) {
            const data = JSON.parse(storedData);
            // setCurrentStep(data.currentStep || 0);
            setAppID(generateId());
            setName(data.name || "");
            setEmail(data.email || "");
            setPhone(data.phone || "");
            setCountryCode(data.country_code || "+1");
            setDob(data.dob || "");
            setDate(data.date || "");
            setTime(data.time || "");
            setDescription(data.description || "");
            setUserGender(data.gender || "");
        }
        fetchFormEnable();
    }, []);

    const updateSlotAvailability = async (docId, day, startTime) => {
        const docRef = doc(db, "doctorAvailability", docId); // Reference to the specific document

        try {
            const docSnapshot = await getDoc(docRef);

            if (docSnapshot.exists()) {
                const data = docSnapshot.data();

                // Update the isAvailable status to false for the specified slot
                const updatedSlots = data[day].map(slot => {
                    if (slot.start === startTime) {
                        return { ...slot, isAvailable: false }; // Mark as unavailable
                    }
                    return slot;
                });

                // Update the Firestore document with the modified array
                await updateDoc(docRef, {
                    [day]: updatedSlots
                });

                console.log("Slot availability updated successfully.");
            } else {
                console.log("Document does not exist!");
            }
        } catch (error) {
            console.error("Error updating slot availability:", error);
        }
    };

    const fetchAllTimeSlots = async () => {
        try {
            setIsLoading(true);
            const slotsCollection = collection(db, "doctorAvailability");
            const snapshot = await getDocs(slotsCollection);

            const fetchedSlots = snapshot.docs.reduce((acc, doc) => {
                const dayData = doc.data();
                const dayName = doc.id; // Use document ID as the weekday (e.g., "Monday")
                acc[dayName] = (dayData.slots || []) // .filter(slot => slot.isAvailable === true); // Store slots for each day
                return (acc);
            }, {});

            // console.log("Fetched slots:", fetchedSlots); // Debug: Check the fetched data
            setAllTimeSlots(fetchedSlots); // Store the fetched slots
            setIsLoading(false); // Stop loading
        } catch (error) {
            console.error("Error fetching time slots:", error);
            setIsLoading(false); // Stop loading on error
        }
    };
    useEffect(() => {

        fetchAllTimeSlots();
    }, []);

    // Convert the selected date into a weekday name (e.g., "Monday")
    // Convert the selected date into a weekday name (normalized to lowercase)
    const getWeekdayFromDate = (date) => {
        const parsedDate = parseISO(date);
        return format(parsedDate, "EEEE").toLowerCase(); // Convert to lowercase
    };

    const fetchAppointmentsByDate = async (date) => {
        try {
            const appointmentsCollection = collection(db, "appointments"); // Adjust the collection name if needed
            const q = query(appointmentsCollection, where("date", "==", date));

            const querySnapshot = await getDocs(q);

            const appointments = querySnapshot.docs.map(doc => ({
                time: doc.data().time
            }));
            return appointments;
        } catch (error) {
            console.error("Error fetching appointments:", error);
        }
    };
    // Update the slots for the selected day when the date changes
    useEffect(() => {
        const fetchData = async () => {
            if (date) {

                const weekdayName = getWeekdayFromDate(date);
                // console.log("Selected Day:", weekdayName); // Log for debugging
                // console.log("Fetched Slots:", allTimeSlots); // Log fetched data

                // Fetch appointments for the selected date
                const allApp = await fetchAppointmentsByDate(date);
                let availableSlots = allTimeSlots[weekdayName] || [];
                // console.log(allApp);
                const currentDate = new Date();
                const currentTime = currentDate.getTime();

                // Filter availableSlots to exclude booked slots and, if today, slots that have already passed
                availableSlots = availableSlots.filter(slot => {
                    const slotTime = new Date(slot.start).getTime();

                    // Check if slot is not booked and, if it's today, if slot time is in the future
                    return !allApp.some(app => app.time.start === slot.start) &&
                        (date !== currentDate.toISOString().split('T')[0] || slotTime > currentTime);
                });
                /*  availableSlots = availableSlots.filter(slot =>
                     !allApp.some(app => app.time.start === slot.start)
                 );    
                 if(date==(new Date().toISOString().split('T')[0])){
                     const currentDate = new Date();
                     const currentTime = currentDate.getTime();
 
                 } */
                // Ensure the slots for the selected day are correctly fetched
                setDaySpecificSlots(availableSlots); // Update state with available slots
            }
        };

        fetchData(); // Call the async function
    }, [date, allTimeSlots]);

    const handleSlotClick = (slot) => {
        setTime({ start: slot.start, end: slot.end });
    };

    useEffect(() => {
        if (currentStep == 0) {
            const input = controlRef.current;

            // Initialize the intlTelInput
            const iti = intlTelInput(input, {
                initialCountry: "US",
                showSelectedDialCode: true,
                hiddenInput: function (telInputName) {
                    return {
                        phone: "phone_full",
                        country: "country_code",
                    };
                },
            });

            // Set initial country code
            setCountryCode(iti.getSelectedCountryData().dialCode);

            // Update country code when the country changes
            input.addEventListener("countrychange", function () {
                const newDialCode = iti.getSelectedCountryData().dialCode;
                setCountryCode(newDialCode);
            });

            // Update phone number on input change
            input.addEventListener("input", function () {
                const number = input.value; // Get the current value of the input
                setPhone(number); // Update the phone number state
            });

            // Clean up the event listener on component unmount
            return () => {
                input.removeEventListener("countrychange", () => { });
                input.removeEventListener("input", () => { });
                iti.destroy(); // Destroy the instance to prevent memory leaks
            };
        }


    }, []);

    const handleMedicationChange = (e) => {
        const { name, value } = e.target;

        setFormData(prevState => ({
            ...prevState,
            mentalHealthDetails: {
                ...prevState.mentalHealthDetails,
                [name]: value,
            },
        }));
    };


    const saveToLocalStorage = () => {
        var appId = generateId();
        setAppID(appId)

        const data = {
            appId,
            name,
            email,
            date: date,
            firstform_depressesed: formData.firstform_depressesed,
            firstform_mentalhealth: formData.firstform_mentalhealth,
            mentalHealthDetails: formData.mentalHealthDetails,
            firstform_psychiatric: formData.firstform_psychiatric,
            medicalHistory: formData.medicalHistory,
            time,
            description: description,
            // gender: userGender,
            status: "pending",
            phone: phone,
            country_code: `+${countryCode} `,
            isCanceled: false,
            // userId: user.uid,
            dob: dob,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),

        };
        localStorage.setItem("appointmentData", JSON.stringify(data));
    };
    const categories = [
        "presentIllness",
        "mood",
        "anxiety",
        "panic",
        "phobia",
        "socialanxiety",
        "maniacsymptons",
        "adhd",
        "self_injury",
        "obsessiveBehaviours",
        "eatingIssues",
        "traumaSymptons",
        "realitySymptons",
        "safetyConcerns",
        "substanceUseDifficulty",
        "neurocognitiveSymtpons",
        "pastHistoryOptions",
        "medicalHistoryOptions",
        "neurologicHistoryOptions",
        "birthControlOptions",
        "medications",
        "familyRelationshipOptions1",
        "socialRelationshipOptions",
        "gender",
        "satisfactionSex",
        "interest",
        "livingSituations",
        "workEducationOptions",
        "relationshipStatusOptions",
        "academicPerformance",
        "academicExperience",
        "academicExperienceOptions",
        "academicIntervention",
        "workPerformanceOptions",
        "workExperienceOptions",
    ];
    const originalName = {
        presentIllness: "HISTORY OF PRESENT ILLNESS",
        mood: "MOOD",
        anxiety: "ANXIETY",
        panic: "PANIC",
        phobia: "SPECIFIC PHOBIA",
        socialanxiety: "SOCIAL ANXIETY",
        maniacsymptons: "MANIC SYMPTOMS",
        adhd: "ADHD SYMPTOMS",
        self_injury: "SELF-INJURIOUS BEHAVIOR",
        obsessiveBehaviours: "OBSESSIVE-COMPULSIVE SYMPTOMS",
        eatingIssues: "EATING ISSUES",
        traumaSymptons: "TRAUMA SYMPTOMS",
        realitySymptons: "REALITY TESTING",
        safetyConcerns: "SAFETY",
        substanceUseDifficulty: "SUBSTANCE USE DIFFICULTIES",
        neurocognitiveSymtpons: "NEUROCOGNITIVE SYMPTOMS",
        pastHistoryOptions: "Past History EARLY DEVELOPMENT",
        medicalHistoryOptions: "MEDICAL HISTORY",
        neurologicHistoryOptions: "NEUROLOGIC HISTORY",
        birthControlOptions: "BIRTH CONTROL",
        medications: "MEDICATIONS",
        familyRelationshipOptions1: "SOCIAL HISTORY Family Relationships",
        socialRelationshipOptions: "SOCIAL HISTORY Social Relationships",
        gender: "SOCIAL HISTORY Gender",
        satisfactionSex: "SOCIAL HISTORY Sex",
        interest: "SOCIAL HISTORY Interest",
        livingSituations: "SOCIAL HISTORY Living Situation",
        workEducationOptions: "SOCIAL HISTORY Work/Education",
        relationshipStatusOptions: "SOCIAL HISTORY Relation Status",
        academicPerformance: "EDUCATION/WORK HISTORY",
        academicExperience: "EDUCATION/WORK HISTORY",
        academicExperienceOptions: "EDUCATION/WORK HISTORY",
        academicIntervention: "EDUCATION/WORK HISTORY",
        workPerformanceOptions: "EDUCATION/WORK HISTORY",
        workExperienceOptions: "EDUCATION/WORK HISTORY",
        mentalHistoryOption: "MENTAL HEALTH HISTORY",
        psychotherapeuticTreatment: "PAST PSYCHOTHERAPEUTIC TREATMENT HISTORY",
        otcMedicationOption: "PAST PSYCHIATRIC TREATMENT HISTORY",
        familyHistoryOptions: "FAMILY PSYCHIATRIC HISTORY",
        familyMedicalOptions: "FAMILY MEDICAL HISTORY",
    }
    const categoriesTextArea = [
        "mentalHistoryOption",
        "psychotherapeuticTreatment",
        "otcMedicationOption",
        "familyHistoryOptions",
        "familyMedicalOptions",
    ];

    const ignoreCheckboxCategory = [
        "presentIllness",
        "pastHistoryOptions",
        "medicalHistoryOptions",
        "birthControlOptions",
        "medications",
        "socialRelationshipOptions",
        "gender",
        "satisfactionSex",
        "interest",
        "livingSituations",
    ];

    const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
        });
    };

    const handleNext = async (e) => {
        // Validate if the current step is not the last one.
        if (currentStep < stepCount - 1) {
            // Perform validation on step 2 (currentStep == 1)

            if (currentStep == 0) {
                e.preventDefault();

                // console.log({
                //     name,
                //     email,
                //     date,
                //     time,
                //     dob,
                //     description,
                //     userGender,
                //     phone,
                //     countryCode,
                //     firstform_depressesed: formData.firstform_depressesed,
                //     firstform_mentalhealth: formData.firstform_mentalhealth,
                //     mentalHealthDetails: formData.mentalHealthDetails,
                //     firstform_psychiatric: formData.firstform_psychiatric,
                //     medicalHistory: formData.medicalHistory,

                // });
                if (
                    !name ||
                    !email ||
                    !date ||
                    !time ||
                    !dob ||
                    !description ||
                    !phone ||
                    !countryCode ||
                    !formData.firstform_depressesed ||
                    (formData.firstform_mentalhealth == "yes" && (
                        !formData.mentalHealthDetails.name ||
                        !formData.mentalHealthDetails.dosage ||
                        !formData.mentalHealthDetails.frequency
                    )) ||
                    !formData.firstform_psychiatric ||
                    (formData.firstform_psychiatric == "yes" && !formData.medicalHistory)
                ) {
                    setFirstFormError(true);
                    return;
                }
                if (date < (new Date().toISOString().split('T')[0])) {
                    setErrorMessage("Please select valid appointment date.");
                    setFirstFormError(true);
                    return;
                }
                setFirstFormError(false);

                saveToLocalStorage();

            }

            if (currentStep == 1) {

                for (let category of categories) {
                    const radioValue = formData[`${category}Radio`];
                    const checkboxArray = formData[category];
                    var section = document.querySelector(`#${category}`);
                    if (section) {
                        if (radioValue === "") {
                            setIsError(true);
                            var msg = `Please select Yes or No for ${originalName[category]}.`;
                            if (category == "presentIllness") {
                                msg = `Please fill detail for ${originalName[category]}.`;
                            }
                            toast.error(<b>{msg}</b>, {
                                position: "top-center",
                                autoClose: 2000,
                            });
                            section.scrollIntoView({ behavior: "smooth", block: "center" });
                            return;
                        } else if (
                            radioValue &&
                            !ignoreCheckboxCategory.includes(category) &&
                            checkboxArray.length == 0
                        ) {
                            setIsError(true);
                            var msg = `Please select at least one checkbox for ${originalName[category]}.`
                            toast.error(<b>{msg}</b>, {
                                position: "top-center",
                                autoClose: 2000,
                            });
                            section.scrollIntoView({ behavior: "smooth" });
                            return;
                        }
                    }
                }
                for (let category of categoriesTextArea) {
                    const radioValue = textAreaData[`${category}Radio`];
                    const fieldValues = textAreaData[category];
                    const section = document.querySelector(`#${category}`);
                    if (section) {
                        if (radioValue === '') {
                            setIsError(true);
                            var msg = `Please select Yes or No for ${originalName[category]}.`
                            toast.error(<b>{msg}</b>, {
                                position: "top-center",
                                autoClose: 2000,
                            });
                            section.scrollIntoView({ behavior: 'smooth' });
                            return;
                        }
                        if (radioValue === true) {
                            const isFieldEmpty = Object.values(fieldValues).some((value) => value.trim() === '');

                            if (isFieldEmpty) {
                                setIsError(true);
                                var msg = `Please fill out all fields for ${originalName[category]} if you answered "Yes".`
                                toast.error(<b>{msg}</b>, {
                                    position: "top-center",
                                    autoClose: 2000,
                                });
                                section.scrollIntoView({ behavior: 'smooth' });
                                return;
                            }
                        }
                    }
                    // Check if radio button is selected



                    // if (currentStep === 1) {
                    //     setIsError(false);
                    //     var flag = false;

                    //     try {
                    //         const formElement = document.querySelector('.second_form'); // Select the form container

                    //         const options = {
                    //             margin: 0.5,
                    //             filename: 'form-data.pdf',
                    //             image: { type: 'jpeg', quality: 0.98 },
                    //             html2canvas: { scale: 2 },
                    //             jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                    //         };

                    //         // Generate PDF from the form element
                    //         const pdfBlob = await html2pdf().from(formElement).set(options).toPdf().output('blob');

                    //         // Convert Blob to Base64 string
                    //         const pdfBase64 = await blobToBase64(pdfBlob);

                    //         // Retrieve existing data from localStorage and add the PDF
                    //         const storedData = JSON.parse(localStorage.getItem('appointmentData')) || {};
                    //         storedData.pdfForm1 = pdfBase64;

                    //         localStorage.setItem('appointmentData', JSON.stringify(storedData));
                    //         alert('PDF saved in localStorage successfully!');
                    //     } catch (error) {
                    //         console.error('Error generating PDF:', error);
                    //         alert('An error occurred while generating the PDF.');
                    //         return;
                    //     }
                    // }

                    // const formElement = document.querySelector('.last_form'); // Select the form container

                    // // PDF options
                    // const options = {
                    //     margin: 0.5,
                    //     filename: 'form-data.pdf',
                    //     image: { type: 'jpeg', quality: 0.98 },
                    //     html2canvas: { scale: 2 },
                    //     jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                    // };

                    // try {
                    //     const pdfBlob = await html2pdf().from(formElement).set(options).toPdf().output('blob');

                    //     // Convert Blob to Base64 string (to store in localStorage)
                    //     const reader = new FileReader();
                    //     reader.readAsDataURL(pdfBlob);

                    //     reader.onloadend = () => {
                    //         const pdfBase64 = reader.result; // Base64 string of the PDF

                    //         // Retrieve any existing data from localStorage
                    //         const storedData = JSON.parse(localStorage.getItem('appointmentData')) || {};
                    //         storedData.pdfForm2 = pdfBase64; // Add PDF Base64 to the data

                    //         // Save updated data back to localStorage
                    //         localStorage.setItem('appointmentData', JSON.stringify(storedData));
                    //     }

                    // } catch (error) {
                    //     console.error('Error generating PDF:', error);
                    //     alert('An error occurred while generating the PDF.');
                    //     return;
                    // }
                }


                if (currentStep === 1) {
                    setIsLoading(true)

                    var nextbtn = document.getElementById("nextbtn");
                    nextbtn.classList.add("disabled");
                    var prevbtn = document.getElementById("prev-btn");
                    prevbtn.classList.add("disabled");
                    setIsError(false);

                    try {
                        const formElement = document.querySelector('.second_form'); // Select the form container

                        const options = {
                            margin: 0.5,
                            filename: 'form-data.pdf',
                            image: { type: 'jpeg', quality: 0.98 },
                            html2canvas: { scale: 2 },
                            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                        };

                        // Generate PDF from the form element
                        const pdfBlob = await html2pdf().from(formElement).set(options).toPdf().output('blob');
                        const pdfBase64 = await blobToBase64(pdfBlob);
                        const pdfPath = await uploadPdfToAPI(pdfBase64, "appointment.pdf");

                        // Convert Blob to Base64 string

                        // Retrieve existing data from localStorage and add the PDF
                        const storedData = JSON.parse(localStorage.getItem('appointmentData')) || {};
                        // storedData.pdfForm1 = pdfBase64;
                        storedData.pdfForm1path = pdfPath;

                        setIsLoading(false)
                        localStorage.setItem('appointmentData', JSON.stringify(storedData));
                        // alert('PDF saved in localStorage successfully!');
                    } catch (error) {
                        console.error('Error generating PDF:', error);
                        setIsLoading(false)
                        // alert('An error occurred while generating the PDF.');
                    } finally {
                        nextbtn.classList.remove("disabled");
                        prevbtn.classList.remove("disabled");
                        setIsLoading(false)
                    }
                }


            }

            // Proceed to the next step
            setCurrentStep((prev) => prev + 1);
        }

    };

    const uploadPdfToAPI = async (pdfBase64, filename) => {
        try {
            const pdfBlob = await fetch(pdfBase64).then(res => res.blob());
            const formData = new FormData();
            formData.append("pdf_file_name", pdfBlob, filename);

            // const response = await fetch("https://www.riderove.com/dev_rove/api/pdf_upload_api/upload_pdf", {
            //     method: "POST",
            //     body: formData,
            // });
            const response = await fetch("https://witcare.health/pdf_upload_api.php", {
                method: "POST",
                body: formData,
            });

            if (!response.ok) throw new Error("Failed to upload PDF");

            const apiResponse = await response.json();
            setIsLoading(false)
            // console.log("Uploaded PDF:", apiResponse);
            return apiResponse.PdfPath; // Return the PDF path

        } catch (error) {
            console.error("Error uploading PDF:", error);
            return null;
        }
    };

    const handleMainRadioChange = (e) => {
        var classname = e.target.value.split("-")[0];
        var val = e.target.value.split("-")[1] == "yes" ? true : false;
        if (e.target.name == "academicExperienceRadio") {
            setFormData({
                ...formData,
                academicPerformanceRadio: val,
                academicExperienceRadio: val,
                academicExperienceOptionsRadio: val,
                academicInterventionRadio: val,
                workPerformanceOptionsRadio: val,
                workExperienceOptionsRadio: val,
            });
        } else {
            setFormData({
                ...formData,
                [e.target.name]: val,
            });
        }
        const element = document.querySelector(`.${classname}`);
        if (val) {
            element.classList.remove("d-none");
        } else {
            element.classList.add("d-none");
            const inputs = document.querySelectorAll(`.${classname} input`);
            inputs.forEach((input) => {
                if (input.type === "checkbox" || input.type === "radio") {
                    input.checked = false;
                } else {
                    input.value = "";
                }
            });
        }
    };

    const handleMainRadioChangeForTextArea = (e) => {
        var classname = e.target.value.split("-")[0];
        var val = e.target.value.split("-")[1] == "yes" ? true : false;

        setTextAreaData({
            ...textAreaData,
            [e.target.name]: val,
        });

        const element = document.querySelector(`.${classname}`);
        if (val) {
            element.classList.remove("d-none");
        } else {
            element.classList.add("d-none");
            const inputs = document.querySelectorAll(`.${classname} input`);
            inputs.forEach((input) => {
                if (input.type === "checkbox" || input.type === "radio") {
                    input.checked = false; // Uncheck checkboxes and radios
                } else {
                    input.value = ""; // Reset other input types
                }
            });
        }
    };



    // Function to validate the select field
    const validateSelectField = () => {
        const selectElement = document.getElementById("phq_difficulty");
        return selectElement && selectElement.value !== "";
    };

    const validateSelectField1 = () => {
        const selectElement = document.getElementById("phq_difficulty1");
        return selectElement && selectElement.value !== "";
    };

    const handlePrev = () => {
        if (currentStep > 0) {
            setCurrentStep((prev) => prev - 1);
        }
    };

    const handleTextAreaChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        const textarea = e.target;
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`; // Adjust to new content
        textarea.style.overflow = "hidden";
    };

    const handleTextAreaChange2 = (e, category) => {
        const { id, value } = e.target;

        setTextAreaData((prevData) => ({
            ...prevData,
            [category]: {
                ...prevData[category],
                [id]: value,
            },
        }));
        const textarea = e.target;
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`; // Adjust to new content
        textarea.style.overflow = "hidden";
    };

    // const handleConfirmAppointment = async () => {
    //     const telehealthConsent = document.getElementById('telehealthConsent').checked;
    //     const privacyNotice = document.getElementById('privacyNotice').checked;
    //     const practicePolicies = document.getElementById('practicePolicies').checked;

    //     if (!telehealthConsent || !privacyNotice || !practicePolicies) {
    //         Swal.fire({
    //             title: "Missing Agreement",
    //             text: "Please agree to all the policies before confirming the appointment.",
    //             icon: "warning",
    //         });
    //         return;
    //     }

    //     return false
    //     Swal.fire({
    //         title: "Appointment Confirmed",
    //         text: "Your appointment has been successfully booked!",
    //         icon: "success",
    //         onClick: navigate('')

    //     });

    //     $('.modal-backdrop').remove()
    //     $('.show').remove()

    //     // $('#confirmationModal').modal('hide');

    //     // Proceed with further booking logic here (like calling an API or closing the modal)
    //     // const modal = bootstrap.Modal.getInstance(document.getElementById('confirmationModal'));
    //     // $('#confirmationModal').modal('hide')
    //     // modal.hide(); // Close the modal
    // };

    // const handleConfirmAppointment = async () => {
    //     const telehealthConsent =
    //         document.getElementById("telehealthConsent").checked;
    //     const privacyNotice = document.getElementById("privacyNotice").checked;
    //     const practicePolicies =
    //         document.getElementById("practicePolicies").checked;

    //     if (!telehealthConsent || !privacyNotice || !practicePolicies) {
    //         Swal.fire({
    //             title: "Missing Agreement",
    //             text: "Please agree to all the policies before confirming the appointment.",
    //             icon: "warning",
    //         });
    //         return;
    //     }

    //     // Retrieve data from localStorage
    //     const storedData = JSON.parse(localStorage.getItem("appointmentData"));
    //     if (!storedData) {
    //         Swal.fire({
    //             title: "Error",
    //             text: "No appointment data found.",
    //             icon: "error",
    //         });
    //         return;
    //     }

    //     // Generate PDFs from form data
    //     // const pdfLinks = await generateAndUploadPDFs(storedData);

    //     // Add appointment details to Firebase
    //     try {
    //         const docRef = await addDoc(collection(db, "appointments"), {
    //             ...storedData,
    //             createdAt: serverTimestamp(),
    //             updatedAt: serverTimestamp(),
    //         });
    //         navigate('/successpage', { state: { email, appId: docRef.id } });
    //         const details = {
    //             email: email,
    //             appId: appId
    //         }
    //         localStorage.setItem('appointment_detail_id', JSON.stringify(details))
    //         setTimeout(() => {
    //             localStorage.removeItem('appointmentData');
    //         }, 1000)

    //         // Swal.fire({
    //         //     title: "Appointment Confirmed",
    //         //     text: "Your appointment has been successfully booked!",
    //         //     icon: "success",
    //         //     showCloseButton: true,
    //         //     html: `
    //         //     <p>Your Email: <strong>${email}</strong></p>
    //         //     <p>Your Appointment ID: <strong>${appId}</strong></p>
    //         //     <button id="navigate-button" className="swal2-confirm swal2-styled" style="margin-top: 10px;">My Appointment Details</button>
    //         // `,
    //         //     willClose: () => {
    //         //         localStorage.removeItem('appointmentData'); // Remove appointment data from localStorage
    //         //         navigate(''); // Navigate to the desired page
    //         //     },
    //         // });
    //         // document.addEventListener('click', (event) => {
    //         //     if (event.target && event.target.id === 'navigate-button') {
    //         //         // Navigate to the desired page when the button is clicked
    //         //         Swal.close(); // Close the Swal

    //         //         navigate('/myappointment'); // Change to your target route

    //         //     }
    //         // });


    //         $(".modal-backdrop").remove();
    //         $(".show").remove();

    //         window.$("#confirmationModal").modal("hide");
    //     } catch (error) {
    //         console.error("Error adding document: ", error);
    //         Swal.fire({
    //             title: "Error",
    //             text: "Could not save appointment details.",
    //             icon: "error",
    //         });
    //     }
    // };

    const handleConfirmAppointment = async () => {
        var cnfbtn = document.getElementById("cnfbtn");
        cnfbtn.classList.add("disabled");
        /*  const telehealthConsent = document.getElementById("telehealthConsent").checked;
         const privacyNotice = document.getElementById("privacyNotice").checked;
         const practicePolicies = document.getElementById("practicePolicies").checked;
 
         if (!telehealthConsent || !privacyNotice || !practicePolicies) {
             Swal.fire({
                 title: "Missing Agreement",
                 text: "Please agree to all the policies before confirming the appointment.",
                 icon: "warning",
             });
             return;
         } */

        // const question10Inputs = document.querySelectorAll('input[data-question="10"]');

        // const phq_each_column_total  = [];
        // question10Inputs.forEach(input => {
        //     phq_each_column_total.push(input.value);  // Push the value of each input into the columnValues array
        // });
        const phq_total_score = document.getElementById('question_11').value;

        // const question08Inputs = document.querySelectorAll('input[data-question-gad="8"]');

        // const gad_each_column_total  = [];
        // question08Inputs.forEach(input => {
        //     gad_each_column_total.push(input.value);  // Push the value of each input into the columnValues array
        // });
        const gad_total_score = document.getElementById('gad-question-total').value;


        const storedData = JSON.parse(localStorage.getItem("appointmentData"));
        if (!storedData) {
            Swal.fire({
                title: "Error",
                text: "No appointment data found.",
                icon: "error",
            });
            cnfbtn.classList.remove("disabled");
            return;
        }

        // Retrieve the Base64 PDF string
        // const pdfBase64 = storedData.pdfForm1; // or whichever key you used to store it

        // // Convert Base64 to Blob
        // const pdfBlob = await fetch(pdfBase64).then(res => res.blob());

        // Create FormData to send to the API
        const formData = new FormData();
        // formData.append("pdf_file_name", pdfPath1, "appointment.pdf"); // Use the key you have

        // Upload the PDF to the API
        try {
            const pdfPath1 = storedData.pdfForm1path;
            const pdfPath2 = storedData.pdfForm2Path;
            // const pdfForm1 = storedData.pdfForm1; // Base64 string of first PDF
            // const pdfForm2 = storedData.pdfForm2; // Base64 string of second PDF

            // const pdfPath1 = await uploadPdfToAPI(pdfForm1, "appointment1.pdf");
            // const pdfPath2 = await uploadPdfToAPI(pdfForm2, "appointment2.pdf");

            // Ensure both PDFs are uploaded successfully
            if (!pdfPath1 || !pdfPath2) {
                throw new Error("Failed to upload PDFs.");
            }

            // Add appointment details to Firebase with both PDF paths
            const appointmentData = {
                ...storedData,
                pdfPath1,
                pdfPath2,
                phq_total_score,
                gad_total_score,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
            };

            delete appointmentData.pdfForm1;
            delete appointmentData.pdfForm2;

            const docRef = await addDoc(collection(db, "appointments"), appointmentData);

            // const docRef = await addDoc(collection(db, "appointments"), {
            //     ...storedData,
            //     pdfPath1, // Store the path of the first PDF
            //     pdfPath2, // Store the path of the second PDF
            //     createdAt: serverTimestamp(),
            //     updatedAt: serverTimestamp(),
            // });



            // Navigate to success page with relevant details
            navigate('/successpage', { state: { email, appId: appId } });

            const details = {
                email: email,
                appId: appId// Use the document reference ID here
            };
            localStorage.setItem('appointment_detail_id', JSON.stringify(details));

            // Clear localStorage after a timeout
            setTimeout(() => {
                localStorage.removeItem('appointmentData');
            }, 1000);

            // Hide the confirmation modal
            $(".modal-backdrop").remove();
            $(".show").remove();
            window.$("#confirmationModal").modal("hide");
            cnfbtn.classList.remove("disabled");
        } catch (error) {
            console.error("Error adding document: ", error);
            Swal.fire({
                title: "Error",
                text: "Could not save appointment details.",
                icon: "error",
            });
        } finally {
            cnfbtn.classList.remove("disabled");
        }
    };


    // e.preventDefault();
    // setLoading(true);
    // await new Promise((res) => setTimeout(res, 3000));
    // setLoading(false);
    // $("#bookingModal").modal("close");

    // if (mainTextArea.length <= "0") {
    //     Swal.fire({
    //         title: 'Form not filled!',
    //         text: 'Please fill up the form before submitting.',
    //         icon: 'warning'

    //         // return
    //     })
    //     return;



    // }

    const validateCheckboxes = () => {
        let isValid = true; // Assume valid initially

        phqQuestions.forEach((question) => {
            // Skip validation for questions 10 and 11
            if (question.id != 10 && question.id != 11) {
                // Select all checkboxes for the current question that are checked
                const checkboxes = document.querySelectorAll(
                    `input[name="question_${question.id}"]:checked`
                );

                // Check if no checkboxes are selected
                if (checkboxes.length === 0) {
                    isValid = false;
                }
            }
        });

        return isValid;
    };

    const validateGadCheckboxes = () => {
        let isValid = true; // Assume valid initially

        gad7Questions.forEach((question) => {
            if (question.id != 8 && question.id != 9) {
                // Select all checkboxes for the current question that are checked
                const checkboxes1 = document.querySelectorAll(
                    `input[name="gad_question_${question.id}"]:checked`
                );

                // Check if no checkboxes are selected
                if (checkboxes1.length === 0) {
                    isValid = false;
                    console.log(`Validation failed for question ${question.id}`); // Log failure
                }
            }
        });

        return isValid;
    };





    // const validateSignature = () => {
    //     const isEmpty = sigCanvas.current.isEmpty();
    //     setSignatureValid(!isEmpty);
    //     return !isEmpty;
    // };
    const handleSubmit = async () => {

        if (currentStep === 2) {
            var submitbtn = document.getElementById("submitbtn");
            submitbtn.classList.add("disabled");
            // Check if `columnGadCounters` is valid

            // Run validations
            const isCheckboxValid = validateCheckboxes();
            const isGadCheckboxesValid = validateGadCheckboxes();
            const isSelectFieldValid = validateSelectField();
            const isSelectField1Valid = validateSelectField1();
            const isColumnCountsValid = columnGadCounters != "0" && columnCounts != "0";

            // Check if any validation failed
            if (
                !isCheckboxValid ||
                !isGadCheckboxesValid ||
                !isSelectFieldValid ||
                !isSelectField1Valid ||
                !isColumnCountsValid
            ) {
                // Re-enable the button if validation fails
                submitbtn.classList.remove("disabled");

                // Show appropriate Swal warning based on the failing condition
                if (!isCheckboxValid) {
                    Swal.fire({
                        title: "Form is not filled.",
                        text: `Please fill the PHQ-9 form before proceeding to the next step!`,
                        icon: "warning",
                    });
                }
                else if (!isGadCheckboxesValid) {
                    Swal.fire({
                        title: "Form is not filled.",
                        text: `Please fill the GAD-7 form before proceeding to the next step!`,
                        icon: "warning",
                    });
                }
                else if (!isSelectFieldValid || !isSelectField1Valid) {
                    Swal.fire({
                        title: "Form is not filled.",
                        text: `Please select the difficulty level  before proceeding to the next step!`,
                        icon: "warning",
                    });
                }

                // Swal.fire({
                //     title: "Form is not filled.",
                //     text: `Please fill the form before proceeding to the next step!` ,
                //     icon: "warning",
                // });

                submitbtn.classList.remove("disabled");
                return;
            }

            if (currentStep === 2) {
                const formElement = document.querySelector('.last_form'); // Select the form container

                // // PDF options
                const options = {
                    margin: 0.5,
                    filename: 'form-data2.pdf',
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                };

                try {
                    const pdfBlob = await html2pdf().from(formElement).set(options).toPdf().output('blob');

                    // Convert Blob to Base64 string (to store in localStorage)
                    // const reader = new FileReader();
                    // reader.readAsDataURL(pdfBlob);

                    // reader.onloadend = () => {
                    //     const pdfBase64 = reader.result; // Base64 string of the PDF

                    //     // Retrieve any existing data from localStorage
                    //     const storedData = JSON.parse(localStorage.getItem('appointmentData')) || {};
                    //     storedData.pdfForm2 = pdfBase64; // Add PDF Base64 to the data

                    //     // Save updated data back to localStorage
                    //     localStorage.setItem('appointmentData', JSON.stringify(storedData));
                    // } /17/12
                    const pdfBase64 = await blobToBase64(pdfBlob);

                    const pdfPath = await uploadPdfToAPI(pdfBase64, "appointment2.pdf");

                    if (!pdfPath) {
                        throw new Error("Failed to upload second PDF.");
                    }

                    // Retrieve any existing data from localStorage
                    const storedData = JSON.parse(localStorage.getItem('appointmentData')) || {};


                    storedData.pdfForm2Path = pdfPath; // Save the returned path

                    // Save the updated data back to localStorage
                    localStorage.setItem('appointmentData', JSON.stringify(storedData));

                    setIsLoading(false);

                } catch (error) {
                    console.error('Error generating PDF:', error);
                    alert('An error occurred while generating the PDF.');
                } finally {
                    submitbtn.classList.remove("disabled");
                }
            }


            // const formElement = document.querySelector('.last_form'); // Select the form container

            // PDF options
            // const options = {
            //     margin: 0.5,
            //     filename: 'form-data.pdf',
            //     image: { type: 'jpeg', quality: 0.98 },
            //     html2canvas: { scale: 2 },
            //     jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
            // };

            // try {
            //     const pdfBlob = await html2pdf().from(formElement).set(options).toPdf().output('blob');

            //     // Convert Blob to Base64 string (to store in localStorage)
            //     const reader = new FileReader();
            //     reader.readAsDataURL(pdfBlob);

            //     reader.onloadend = () => {
            //         const pdfBase64 = reader.result; // Base64 string of the PDF

            //         // Retrieve any existing data from localStorage
            //         const storedData = JSON.parse(localStorage.getItem('appointmentData')) || {};
            //         storedData.pdfForm2 = pdfBase64; // Add PDF Base64 to the data

            //         // Save updated data back to localStorage
            //         localStorage.setItem('appointmentData', JSON.stringify(storedData));
            //     }

            // } catch (error) {
            //     console.error('Error generating PDF:', error);
            //     alert('An error occurred while generating the PDF.');
            //     return;
            // }
        }

        // if (formData[formName].length === 0) {
        //     // setError(prev => ({ ...prev, [formName]: 'Please select at least one option.' }));
        //     ref.current.scrollIntoView({ behavior: 'smooth' }); // Scroll to the specific section
        //     return; // Prevent further action
        // }

        window.$("#confirmationModal").modal("show");
        submitbtn.classList.remove("disabled");
        // if()

        // setShowSuccess(true);
        // Swal.fire({
        //     title: "Success!",
        //     text: "We will confirm  by an Text Message !",
        //     icon: "success",
        // });
        // navigate("");
    };

    const sigCanvas = useRef();

    const clearSignature = () => sigCanvas.current.clear();
    const saveSignature = () => {
        const data = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    };

    const handleDepressionChange = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            feelingDepressed: e.target.value,
        }));
    };



    const ModalCloseHandler = () => {
        removeLocalStorage()
        $('.modal-backdrop').remove()
        $('.show').remove()
    }

    // const handleCheckboxChange = (columnIndex, isChecked) => {
    //     const updatedCounts = [...columnCounts];

    //     // Update count based on whether checkbox is checked or unchecked
    //     updatedCounts[columnIndex] += isChecked ? 1 : -1;

    //     setColumnCounts(updatedCounts);
    // };

    const handleCheckboxChange = (questionId, value, isChecked) => {
        setScores((prevScores) => ({
            ...prevScores,
            [questionId]: isChecked ? value : null, // Update to the new value or null if unchecked
        }));

        const updatedCounts = [...columnCounts];

        // Reset the column value before adding the new value (if any)
        // Find the previous value that was set for this question and subtract it from the count.
        if (scores[questionId] !== null) {
            updatedCounts[scores[questionId]] -= scores[questionId];
        }

        // Add the new value to the respective column if checked
        if (isChecked) {
            updatedCounts[value] += value;
        }

        setColumnCounts(updatedCounts); // Update the column counts state
    };


    const calculateTotalScore = () => {
        return Object.values(scores).reduce((total, score) => total + score, 0);
    };

    // const handleQadCheckboxChange = (questionId, value, isChecked) => {
    //     const updatedCounts = [...columnGadCounters];

    //     // Update count based on whether checkbox is checked or unchecked
    //     updatedCounts[columnIndex] += isChecked ? 1 : -1;

    //     setcolumnGadCounters(updatedCounts);
    // };

    const handleQadCheckboxChange = (questionId, value, isChecked) => {
        setgadScores((prevGadScores) => ({
            ...prevGadScores,
            [questionId]: isChecked ? value : null,
        }));

        const updatedCounts = [...columnGadCounters];

        // If there's a previous value, decrement the count
        if (gadScores[questionId] !== null) {
            updatedCounts[gadScores[questionId]] -= gadScores[questionId];
        }

        // Add the new value to the respective column if checked
        if (isChecked) {
            updatedCounts[value] += value;
        }

        setcolumnGadCounters(updatedCounts)
    };




    const calculateTotalQadScore = () => {
        // console.log(gadScores)
        return Object.values(gadScores).reduce((total, score) => total + score, 0);
    };

    const handlePhoneChange = (e) => {
        var d = e.target.value
    }

    const removeLocalStorage = () => {
        navigate('/')
        localStorage.removeItem('appointmentData')
    }



    // useEffect(() => {
    //     const input = controlref.current;

    //     iti = intlTelInput(input, {
    //         initialCountry: "US",
    //         showSelectedDialCode: true,
    //         hiddenInput: function (telInputName) {
    //             return {
    //                 phone: "phone_full",
    //                 country: "country_code",
    //             };
    //         },
    //     });

    //     // Set initial country code
    //     setCountryCode(iti.getSelectedCountryData().dialCode);

    //     // Update country code when the country changes
    //     input.addEventListener("countrychange", function () {
    //         let newDialCode = iti.getSelectedCountryData().dialCode;
    //         setCountryCode(newDialCode);

    //     });
    // }, []);

    return (
        <div
            ref={modalContentRef}
            id="qbox-container"
            className="appointment_form"
            style={{
                // backgroundImage: `url(${backgroundImage})`,
                background: "",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover", // Adjust as needed
            }}
        >
            <div className="progress">
                <div
                    className="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                    role="progressbar"
                    style={{ width: `${progressWidth}%` }}
                    aria-valuenow={progressWidth}
                    aria-valuemin={0}
                    aria-valuemax={100}
                />
            </div>

            <div className="mb-5">
                <button to="" onClick={() => removeLocalStorage()}  className="close close-btn" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            {loading && (
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                // <div id="preloader-wrapper" className="d-block">
                //     Loading...
                // </div>
            )}
            {showSuccess && (
                <div id="success" className="d-block">
                    Success!
                </div>
            )}

            <form className="needs-validation" onSubmit={(e) => handleNext(e)}>
                <div className="booking-card steps-container">
                    {currentStep == 0 && (
                        <div className="step d-block">
                            <div className="row">
                                <div className="col-lg-6 d-flex justify-content-center align-items-center">
                                    <img
                                        src="/assets/img/appointment_img.jpeg"
                                        alt="Doctor consultation"
                                        className=" form-image"
                                        style={{ borderRadius:'15px' , height:'75%' , width:'80%' }}
                                    />
                                </div>

                                <div className="col-lg-6 mt-4 mt-md-0 mb-4 mb-md-0 col-12">
                                    {/* <div className="col-md-12">
                                        <button
                                            type="button"
                                            className="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                        >
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div> */}
                                    {/* <div className="col-md-10">
                                        <div className="progress-circles mb-4">
                                            <div className="progress-circle active" />
                                            <div className="progress-line" />
                                            <div className="progress-circle active" />
                                            <div className="progress-line" />
                                            <div className="progress-circle active" />
                                            <div className="progress-line" />
                                            <div className="progress-circle active" />
                                            <div className="progress-line" />
                                            <div className="progress-circle" />
                                        </div>
                                    </div> */}
                                    <h2 className="mb-4">We Are Always Ready to Help You.</h2>
                                    <h3 className="text-primary mb-4">Book An Appointment</h3>
                                    <form id="appointmentForm">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Patient name"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required=""
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-6">
                                                <div className=" focused">
                                                    <label className="label">Phone no.</label> <br />
                                                    <input
                                                        type="text"
                                                        id="countrySelect"
                                                        placeholder="Phone"
                                                        style={{ width: '100%' }}
                                                        onChange={handlePhoneChange}
                                                        maxLength={10}
                                                        value={phone}
                                                        ref={controlRef}
                                                        className="form-control "
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-6">
                                                <label htmlFor="dob" className="label">Date of Birth</label>
                                                <input
                                                    type="date"
                                                    className="form-control "
                                                    id="dob"
                                                    value={dob}
                                                    onChange={(e) => setDob(e.target.value)}
                                                    max={new Date("2020-01-01").toISOString().split('T')[0]}
                                                    required=""
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* <div className="col-md-6 mb-3 ">
                                                <div className='form-group'>
                                                    <sselect className="form-control nice-select wide " required="">
                                                        <option value="">Doctor</option>
                                                        <option value="dr-sambhav"> Dr. Sandhya Chinala</option>
                                                    </sselect>
                                                </div>
                                            </div> */}
                                            <div className="col-md-6 mb-3">
                                                <label className="label">Appointment Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    required=""
                                                    value={date}
                                                    min={new Date().toISOString().split('T')[0]}
                                                    onChange={(e) => setDate(e.target.value)}
                                                />
                                            </div>
                                            {/* <div className="col-md-6 w-100 mb-3">
                                                <label htmlFor="gender">Gender</label>
                                                <select
                                                    className="select form-control w-100"
                                                    value={userGender}
                                                    onChange={(e) => setUserGender(e.target.value)}
                                                >
                                                    <option>Select Gender</option>
                                                    <option value="male">Male</option>
                                                    <option value="female">Female</option>
                                                    <option value="none">Prefer not to say</option>
                                                </select>
                                            </div> */}
                                            <div className="col-md-12">
                                                <label className="label">Available Time Slots</label>
                                                {isLoading ? (
                                                    <p>Loading...</p>
                                                ) : daySpecificSlots.length > 0 ? (
                                                    <div className="d-flex flex-wrap">
                                                        {daySpecificSlots.map((slot, index) => (
                                                            <div
                                                                key={index}
                                                                // className={`"card p-2 m-2 border`}
                                                                className={`slot-card p-2 m-2 ${time.start === slot.start ? "selected" : ""
                                                                    }`}
                                                                style={{ width: "120px", cursor: "pointer" }}
                                                                onClick={() => handleSlotClick(slot)}
                                                            >
                                                                <p className="mb-1 text-center">
                                                                    {slot.start} - {slot.end}
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p>No available time slots for this day.</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="mb-4">
                                            <div className="mb-3">
                                                <label className="mb-4 label">
                                                    Have you been feeling depressed lately?
                                                </label><span className="text-danger"> * </span>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_depressesed"
                                                        value="yes"
                                                        id="firstform_depresses_yes"
                                                        onChange={(e) =>
                                                            handleFirstFormRadioChange(
                                                                e,
                                                                "firstform_depressesed"
                                                            )
                                                        } />
                                                    <label
                                                        className="form-label"
                                                        htmlFor="input_f2_1"
                                                    >
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_depressesed"
                                                        id="firstform_depresses_no"
                                                        value="no"
                                                        onChange={(e) =>
                                                            handleFirstFormRadioChange(
                                                                e,
                                                                "firstform_depressesed"
                                                            )
                                                        }
                                                    />
                                                    <label
                                                        className="form-label"
                                                        htmlFor="input_f2_0"
                                                    >
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label className="mb-4 label">
                                                    Have you ever been prescribed mental health medications?
                                                </label><span className="text-danger"> * </span>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_mentalhealth"
                                                        value="yes"
                                                        id="firstform_mentalhealth_yes"
                                                        onChange={(e) => handleFirstFormRadioChange(e, "firstform_mentalhealth")}
                                                    />
                                                    <label className="form-label" htmlFor="firstform_mentalhealth_yes">Yes</label>
                                                </div>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_mentalhealth"
                                                        value="no"
                                                        id="firstform_mentalhealth_no"
                                                        onChange={(e) => handleFirstFormRadioChange(e, "firstform_mentalhealth")}
                                                    />
                                                    <label className="form-label" htmlFor="firstform_mentalhealth_no">No</label>
                                                </div>
                                                {formData.firstform_mentalhealth === 'yes' && (
                                                    <div className="mt-3">
                                                        <label className="mb-2">Please provide name, dosage, and frequency:</label>
                                                        <input
                                                            type="text"
                                                            className="form-control mb-2"
                                                            placeholder="Name"
                                                            name="name"
                                                            value={formData.mentalHealthDetails.name}
                                                            onChange={handleMedicationChange}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control mb-2"
                                                            placeholder="Dosage"
                                                            name="dosage"
                                                            value={formData.mentalHealthDetails.dosage}
                                                            onChange={handleMedicationChange}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control mb-2"
                                                            placeholder="Frequency"
                                                            name="frequency"
                                                            value={formData.mentalHealthDetails.frequency}
                                                            onChange={handleMedicationChange}
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            <div className="mb-3">
                                                <label className="mb-4 label">
                                                    Any history of inpatient psychiatric Hospitalizations?
                                                </label><span className="text-danger"> * </span>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_psychiatric"
                                                        value="yes"
                                                        id="firstform_psychiatric_yes"
                                                        onChange={(e) => handleFirstFormRadioChange(e, "firstform_psychiatric")}
                                                    />
                                                    <label className="form-label" htmlFor="firstform_psychiatric_yes">Yes</label>
                                                </div>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_psychiatric"
                                                        value="no"
                                                        id="firstform_psychiatric_no"
                                                        onChange={(e) => handleFirstFormRadioChange(e, "firstform_psychiatric")}
                                                    />
                                                    <label className="form-label" htmlFor="firstform_psychiatric_no">No</label>
                                                </div>
                                                {formData.firstform_psychiatric === 'yes' && (
                                                    <div className="mt-3">
                                                        <label className="mb-2">Medical history :</label>
                                                        <textarea
                                                            className="form-control"
                                                            rows={3}
                                                            placeholder="Write your message here"
                                                            value={formData.medicalHistory}
                                                            onChange={(e) => setFormData({ ...formData, medicalHistory: e.target.value })}
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            {/* <div className="mb-3">
                                                <label className="mb-4 label">
                                                    Have you been feeling depressed lately?
                                                </label><span className="text-danger"> * </span>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_depressesed"
                                                        value="yes"
                                                        id="firstform_depresses_yes"
                                                        onChange={(e) =>
                                                            handleRadioChange(
                                                                e,
                                                                "firstform_depressesed"
                                                            )
                                                        } />
                                                    <label
                                                        className="form-label"
                                                        htmlFor="input_f2_1"
                                                    >
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_depressesed"
                                                        id="firstform_depresses_no"
                                                        value="no"
                                                        onChange={(e) =>
                                                            handleRadioChange(
                                                                e,
                                                                "firstform_depressesed"
                                                            )
                                                        }
                                                    />
                                                    <label
                                                        className="form-label"
                                                        htmlFor="input_f2_0"
                                                    >
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label className="mb-4 label">
                                                    Have you ever been prescribed, mental health medications?
                                                </label><span className="text-danger"> * </span>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_mentalhealth"
                                                        value="yes"
                                                        id="firstform_mentalhealth_yes"
                                                        onChange={(e) => handleRadioChange(e, "firstform_mentalhealth") }
                                                        />
                                                    <label
                                                        className="form-label"
                                                        htmlFor="firstform_mentalhealth_yes"
                                                    >
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_mentalhealth"
                                                        id="firstform_mentalhealth_no"
                                                        value="no"
                                                        onChange={(e) => handleRadioChange(e, "firstform_mentalhealth") }

                                                    />
                                                    <label
                                                        className="form-label"
                                                        htmlFor="firstform_mentalhealth_no"
                                                    >
                                                        No
                                                    </label>
                                                </div>
                                                {formData.firstform_mentalhealth == 'firstform_mentalhealth_yes' && (
                                                    <div className="mt-3">
                                                        <label className="mb-2">Please provide name, dosage, and frequency:</label>
                                                        <input type="text" className="form-control mb-2" placeholder="Name" />
                                                        <input type="text" className="form-control mb-2" placeholder="Dosage" />
                                                        <input type="text" className="form-control mb-2" placeholder="Frequency" />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="mb-3">
                                                <label className="mb-4 label">
                                                Any history of inpatient psychiatric Hospitalizations?
                                                </label><span className="text-danger"> * </span>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_psychiatric"
                                                        value="yes"
                                                        id="firstform_psychiatric_yes"
                                                        onChange={(e) => handleRadioChange(e, "firstform_psychiatric") }
                                                        />
                                                    <label
                                                        className="form-label"
                                                        htmlFor="firstform_psychiatric_yes"
                                                    >
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="form-check ml-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="firstform_psychiatric"
                                                        id="firstform_psychiatric_no"
                                                        value="no"
                                                        onChange={(e) => handleRadioChange(e, "firstform_psychiatric") }

                                                    />
                                                    <label
                                                        className="form-label"
                                                        htmlFor="firstform_psychiatric_no"
                                                    >
                                                        No
                                                    </label>
                                                </div>
                                                {formData.firstform_psychiatric == 'firstform_psychiatric_yes' && (
                                                    <div className="mt-3">
                                                        <label className="mb-2">Medical history :</label>
                                                        <textarea  className="form-control"
                                                        rows={3}
                                                        placeholder="Write your message here"
                                                        defaultValue={""}/>
                                                    </div>
                                                )}
                                            </div> */}
                                        </div>
                                        <div className="mb-4">
                                            <label className="label">Presenting Problem (please briefly explain your concerns)                                            </label>
                                            <span className="text-danger">*</span>
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                placeholder="Write your message here"
                                                defaultValue={""}
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                            />
                                        </div>
                                    </form>

                                    {firstFormError && (
                                        <div className="alert alert-danger">
                                            {errorMessage}
                                        </div>
                                    )}

                                    {/* Links or buttons to open PDF files */}
                                    <div className="mb-4 mb-md-0">
                                        <h5 className="mb-3">Terms & conditions<span className="text-danger">*</span>&nbsp;:</h5>
                                        <label className="label">Accepting only SELF PAY at this time. </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {
                           isLoading ?
                           <div className="col-12 d-flex justify-content-center align-items-center vh-100">
                               <div class="spinner-border text-primary" role="status">
                                   <span class="sr-only">Loading...</span>
                               </div>
                           </div>
                           :
                        currentStep == 1 && (
                            <div className="step d-block">
                                <div className="step d-block">
                                    {/* <embed src={pdf2} type="application/pdf" width="100%" height="800px" /> */}
                                    <div className="container-fluid mt-5">
                                        <div className="d-flex flex-column justify-content-center">
                                            <h5 className="text-center mb-4">Intake Questionnaire</h5>
                                            <hr />
                                        </div>
                                        <h6 className="d-flex justify-content-end mb-5">
                                            <span className="text-danger">*</span> &nbsp;indicates a
                                            required field
                                        </h6>
                                    </div>

                                    <form className="second_form">
                                        <div className="row ">
                                            {enableForms && enableForms["History of Present Illness"] && <div className="col-md-6 col-lg-6 mb-4">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            HISTORY OF PRESENT ILLNESS
                                                        </h5>
                                                        <div className="mb-3" id="presentIllness">
                                                            <label htmlFor="input_f1_1" className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                How can I help you? What are your biggest
                                                                concerns?
                                                            </label>
                                                            <textarea
                                                                type="text"
                                                                className="form-control"
                                                                name="presentIllnessRadio"
                                                                id="input_f1_1"
                                                                onChange={handleTextAreaChange}
                                                            />
                                                        </div>
                                                        <h6 className="mb-4">
                                                            How have you been functioning lately?
                                                        </h6>
                                                        {options1.map((option) => (
                                                            <div className="form-check ml-4" key={option.id}>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={option.id}
                                                                    onChange={(e) =>
                                                                        handleCheckboxChange1(e, "presentIllness")
                                                                    }
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={option.id}
                                                                >
                                                                    {option.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["MOOD"] && <div className="col-md-6 col-lg-6 mb-4" id="mood">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">MOOD</h5>
                                                        <div className="mb-3">
                                                            <h6 className="mb-4">
                                                                <span className="text-danger"> * </span>
                                                                Have you been feeling depressed lately?
                                                            </h6>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="moodRadio"
                                                                    value="FR_1-yes"
                                                                    id="input_f2_1"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="input_f2_1"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="moodRadio"
                                                                    id="input_f2_0"
                                                                    value="FR_1-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="input_f2_0"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_1 d-none">
                                                            {formData.mood && (
                                                                <>
                                                                    <h6 className="mb-4">
                                                                        If you answered yes to the above question,
                                                                        please provide more details:
                                                                    </h6>
                                                                    <div className="row mb-4">
                                                                        <div className="col-md-6">
                                                                            {moodOptions.slice(0, 7).map((data) => (
                                                                                <Checkbox
                                                                                    className="ml-4"
                                                                                    key={data.id}
                                                                                    id={data.id}
                                                                                    label={data.label}
                                                                                    checked={formData.mood.includes(
                                                                                        data.id
                                                                                    )}
                                                                                    onChange={(e) =>
                                                                                        handleCheckboxChange1(e, "mood")
                                                                                    }
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            {moodOptions.slice(7).map((data) => (
                                                                                <Checkbox
                                                                                    className="ml-4"
                                                                                    key={data.id}
                                                                                    id={data.id}
                                                                                    label={data.label}
                                                                                    checked={formData.mood.includes(
                                                                                        data.id
                                                                                    )}
                                                                                    onChange={(e) =>
                                                                                        handleCheckboxChange1(e, "mood")
                                                                                    }
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}

                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="input_f2_18"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about depressive symptoms
                                                                </label>
                                                                <textarea
                                                                    type="text"
                                                                    onChange={handleTextAreaChange}
                                                                    className="form-control"
                                                                    name="input_f2_18"
                                                                    id="input_f2_18"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["ANXIETY"] && <div className="col-md-6 col-lg-6 mb-4" id="anxiety">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">ANXIETY</h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Have you been feeling anxiety lately?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="anxietyRadio"
                                                                    id="anxiety-yes"
                                                                    value="FR_2-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="anxiety-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="anxietyRadio"
                                                                    id="anxiety-no"
                                                                    value="FR_2-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="anxiety-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_2 d-none">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="ml-4 mb-3">
                                                                {anxietyOptions.map((data) => (
                                                                    <Checkbox
                                                                        id={data.id}
                                                                        key={data.id}
                                                                        // className="ml-4"
                                                                        label={data.label}
                                                                        checked={formData.anxiety.includes(data.id)}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange1(e, "anxiety")
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="anxiety-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about anxiety symptoms:
                                                                </label>
                                                                <textarea
                                                                    onChange={handleTextAreaChange}
                                                                    className="form-control"
                                                                    id="anxiety-comments"
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["PANIC"] && <div className="col-md-6 col-lg-6 mb-4" id="panic">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">PANIC</h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Have you been experiencing panic lately?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="panicRadio"
                                                                    id="panic-yes"
                                                                    value="FR_3-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label className="form-label" htmlFor="panic-yes">
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="panicRadio"
                                                                    id="panic-no"
                                                                    value="FR_3-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label className="form-label" htmlFor="panic-no">
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_3 d-none  mb-2">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="row ml-2">
                                                                <div className="col-md-6 mb-0">
                                                                    {panicOptions.slice(0, 7).map((data) => (
                                                                        <Checkbox
                                                                            key={data.id}
                                                                            id={data.id}
                                                                            label={data.label}
                                                                            checked={formData.panic.includes(data.id)}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(e, "panic")
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                                <div className="col-md-6 mb-0">
                                                                    {panicOptions.slice(7).map((data) => (
                                                                        <Checkbox
                                                                            key={data.id}
                                                                            id={data.id}
                                                                            label={data.label}
                                                                            className="ml-0"
                                                                            checked={formData.panic.includes(data.id)}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(e, "panic")
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="anxiety-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about anxiety symptoms:
                                                                </label>
                                                                <textarea
                                                                    onChange={handleTextAreaChange}
                                                                    className="form-control"
                                                                    id="anxiety-comments"
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["SPECIFIC PHOBIA"] && <div className="col-md-6 col-lg-6 mb-4" id="phobia">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">SPECIFIC PHOBIA</h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Do you have phobias?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="phobiaRadio"
                                                                    id="phobia-yes"
                                                                    value="FR_4-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="phobia-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="phobiaRadio"
                                                                    id="phobia-no"
                                                                    value="FR_4-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label className="form-label" htmlFor="phobia-no">
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="d-none FR_4">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="ml-4 mb-3">
                                                                {phobiaOptions.map((data) => (
                                                                    <Checkbox
                                                                        id={data.id}
                                                                        key={data.id}
                                                                        label={data.label}
                                                                        checked={formData.phobia.includes(data.id)}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange1(e, "phobia")
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="phobia-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about anxiety symptoms:
                                                                </label>
                                                                <textarea
                                                                    onChange={handleTextAreaChange}
                                                                    className="form-control"
                                                                    id="phobia-comments"
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["SOCIAL ANXIETY"] && <div className="col-md-6 col-lg-6 mb-4" id="socialanxiety">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">SOCIAL ANXIETY</h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Have you been feeling social anxiety lately?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="socialanxietyRadio"
                                                                    id="social-anxiety-yes"
                                                                    value="FR_5-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="social-anxiety-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="socialanxietyRadio"
                                                                    id="social-anxiety-no"
                                                                    value="FR_5-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="social-anxiety-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_5 d-none">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="ml-4 mb-3">
                                                                {socialAnxietyOptions.map((data) => (
                                                                    <Checkbox
                                                                        id={data.id}
                                                                        key={data.id}
                                                                        label={data.id}
                                                                        checked={formData.socialanxiety.includes(
                                                                            data.id
                                                                        )}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange1(e, "socialanxiety")
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="social-anxiety-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about anxiety symptoms:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="social-anxiety-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["MANIC SYMPTOMS"] && <div className="col-md-6 col-lg-6 mb-4" id="maniacsymptons">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">MANIC SYMPTOMS</h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Have you been feeling manic lately?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="maniacsymptonsRadio"
                                                                    id="manic-lately-yes"
                                                                    value="FR_6-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="manic-lately-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="maniacsymptonsRadio"
                                                                    id="manic-lately-no"
                                                                    value="FR_6-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="manic-lately-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_6 d-none  mb-2">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="row ml-2">
                                                                <div className="col-md-6 mb-0">
                                                                    {maniacOptions.slice(0, 6).map((data) => (
                                                                        <Checkbox
                                                                            id={data.id}
                                                                            key={data.id}
                                                                            className="ml-0"
                                                                            label={data.id}
                                                                            checked={formData.maniacsymptons.includes(
                                                                                data.id
                                                                            )}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(e, "maniacsymptons")
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                                <div className="col-md-6 mb-0">
                                                                    {maniacOptions.slice(6).map((data) => (
                                                                        <Checkbox
                                                                            id={data.id}
                                                                            key={data.id}
                                                                            className="ml-0"
                                                                            label={data.id}
                                                                            checked={formData.maniacsymptons.includes(
                                                                                data.id
                                                                            )}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(e, "maniacsymptons")
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="manic-lately-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about elevated mood
                                                                    symptoms:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="manic-lately-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["ADHD SYMPTOMS"] && <div className="col-md-6 col-lg-6 mb-4" id="adhd">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">ADHD SYMPTOMS</h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Have you had symptoms of inattention or
                                                                hyperactivity lately?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="adhdRadio"
                                                                    id="adhd-yes"
                                                                    value="FR_7-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label className="form-label" htmlFor="adhd-yes">
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="adhdRadio"
                                                                    id="adhd-no"
                                                                    value="FR_7-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label className="form-label" htmlFor="adhd-no">
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_7 d-none mb-2">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="row  ml-2">
                                                                <div className="col-md-6 mb-0">
                                                                    {adhdOptions.slice(0, 9).map((data) => (
                                                                        <Checkbox
                                                                            id={data.id}
                                                                            key={data.key}
                                                                            className="ml-0"
                                                                            label={data.label}
                                                                            checked={formData.adhd.includes(data.id)}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(e, "adhd")
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                                <div className="col-md-6 mb-0">
                                                                    {adhdOptions.slice(9).map((data) => (
                                                                        <Checkbox
                                                                            id={data.id}
                                                                            key={data.key}
                                                                            className="ml-0"
                                                                            label={data.label}
                                                                            checked={formData.adhd.includes(data.id)}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(e, "adhd")
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="adhd-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about inattention,
                                                                    organization or hyperactivitysymptoms :
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="adhd-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["SELF-INJURIOUS BEHAVIOR"] && <div className="col-md-6 col-lg-6 mb-4" id="self_injury">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            SELF-INJURIOUS BEHAVIOR
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Do you engage in self-injurious behaviors?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="self_injuryRadio"
                                                                    id="self-injurious-yes"
                                                                    value="FR_8-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="self-injurious-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="self_injuryRadio"
                                                                    id="self-injurious-no"
                                                                    value="FR_8-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="self-injurious-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_8 d-none">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="ml-4 mb-3">
                                                                {selfInjuriousBehaviors.map((data) => (
                                                                    <Checkbox
                                                                        id={data.id}
                                                                        key={data.key}
                                                                        className="ml-0"
                                                                        label={data.label}
                                                                        checked={formData.self_injury.includes(
                                                                            data.id
                                                                        )}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange1(e, "self_injury")
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="self-injurious-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about self-injurious
                                                                    behavior:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="self-injurious-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["OBSESSIVE-COMPULSIVE SYMPTOMS"] && <div className="col-md-6 col-lg-6 mb-4" id="obsessiveBehaviours">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            OBSESSIVE-COMPULSIVE SYMPTOMS
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Do you engage in obsessive thinking or compulsive
                                                                behaviors?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="obsessiveBehavioursRadio"
                                                                    id="obsessive-yes"
                                                                    value="FR_9-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="obsessive-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="obsessiveBehavioursRadio"
                                                                    id="obsessive-no"
                                                                    value="FR_9-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="obsessive-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_9 d-none">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="ml-4 mb-3">
                                                                {obsessiveCompulsiveBehaviors.map((data) => (
                                                                    <Checkbox
                                                                        id={data.id}
                                                                        key={data.key}
                                                                        className="ml-0"
                                                                        label={data.label}
                                                                        checked={formData.obsessiveBehaviours.includes(
                                                                            data.id
                                                                        )}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange1(
                                                                                e,
                                                                                "obsessiveBehaviours"
                                                                            )
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="obsessive-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about obsessive-compulsive
                                                                    symptoms:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="obsessive-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["EATING ISSUES"] && <div className="col-md-6 col-lg-6 mb-4" id="eatingIssues">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">EATING ISSUES</h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Do you engage in behaviors affecting eating or
                                                                weight?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="eatingIssuesRadio"
                                                                    id="eating-issues-yes"
                                                                    value="FR_10-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="eating-issues-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="eatingIssuesRadio"
                                                                    id="eating-issues-no"
                                                                    value="FR_10-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="eating-issues-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_10 d-none  mb-3">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="ml-4">
                                                                {eatingIssues.map((data) => (
                                                                    <Checkbox
                                                                        id={data.id}
                                                                        key={data.key}
                                                                        className="ml-0"
                                                                        label={data.label}
                                                                        checked={formData.eatingIssues.includes(
                                                                            data.id
                                                                        )}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange1(e, "eatingIssues")
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["TRAUMA SYMPTOMS"] && <div className="col-md-6 col-lg-6 mb-4" id="traumaSymptons">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">TRAUMA SYMPTOMS</h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Have you experienced physical, sexual, emotional
                                                                abuse or neglect, orother kinds of trauma?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="traumaSymptonsRadio"
                                                                    id="trauma-yes"
                                                                    value="FR_11-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="trauma-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="traumaSymptonsRadio"
                                                                    id="trauma-no"
                                                                    value="FR_11-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label className="form-label" htmlFor="trauma-no">
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_11 d-none  mb-2">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="row ml-2">
                                                                <div className="col-md-6 mb-0">
                                                                    {traumaSymptomsOptions
                                                                        .slice(0, 10)
                                                                        .map((data) => (
                                                                            <Checkbox
                                                                                id={data.id}
                                                                                key={data.key}
                                                                                className="ml-0"
                                                                                label={data.label}
                                                                                checked={formData.traumaSymptons.includes(
                                                                                    data.id
                                                                                )}
                                                                                onChange={(e) =>
                                                                                    handleCheckboxChange1(
                                                                                        e,
                                                                                        "traumaSymptons"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                </div>
                                                                <div className="col-md-6 mb-0">
                                                                    {traumaSymptomsOptions.slice(11).map((data) => (
                                                                        <Checkbox
                                                                            id={data.id}
                                                                            key={data.key}
                                                                            className="ml-0"
                                                                            label={data.label}
                                                                            checked={formData.traumaSymptons.includes(
                                                                                data.id
                                                                            )}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(e, "traumaSymptons")
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="trauma-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about traumatic symptoms :
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    onChange={handleTextAreaChange}
                                                                    id="trauma-comments"
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["REALITY TESTING"] && <div className="col-md-6 col-lg-6 mb-4" id="realitySymptons">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">REALITY TESTING</h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Does your mind ever play tricks on you, or do you
                                                                experience thingsothers don't experience?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="realitySymptonsRadio"
                                                                    id="reality-yes"
                                                                    value="FR_12-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="reality-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="realitySymptonsRadio"
                                                                    id="reality-no"
                                                                    value="FR_12-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="reality-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_12 d-none mb-2">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="row ml-2">
                                                                <div className="col-md-6 mb-0">
                                                                    {realitySymptomsOptions
                                                                        .slice(0, 6)
                                                                        .map((data) => (
                                                                            <Checkbox
                                                                                id={data.id}
                                                                                key={data.key}
                                                                                className="ml-0"
                                                                                label={data.label}
                                                                                checked={formData.realitySymptons.includes(
                                                                                    data.id
                                                                                )}
                                                                                onChange={(e) =>
                                                                                    handleCheckboxChange1(
                                                                                        e,
                                                                                        "realitySymptons"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                </div>

                                                                <div className="col-md-6 mb-0">
                                                                    {realitySymptomsOptions.slice(6).map((data) => (
                                                                        <Checkbox
                                                                            id={data.id}
                                                                            key={data.key}
                                                                            className="ml-0"
                                                                            label={data.label}
                                                                            checked={formData.realitySymptons.includes(
                                                                                data.id
                                                                            )}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(
                                                                                    e,
                                                                                    "realitySymptons"
                                                                                )
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="reality-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about psychotic symptoms :
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="reality-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["SAFETY"] && <div className="col-md-6 col-lg-6 mb-4" id="safetyConcerns">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">SAFETY</h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Have you had thoughts of wanting to die, or have
                                                                you tried to killyourself?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="safetyConcernsRadio"
                                                                    id="safety-yes"
                                                                    value="FR_13-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="safety-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="safetyConcernsRadio"
                                                                    id="safety-no"
                                                                    value="FR_13-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label className="form-label" htmlFor="safety-no">
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_13 d-none">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="ml-4 mb-3">
                                                                {safetyConcernsOptions.map((data) => (
                                                                    <Checkbox
                                                                        id={data.id}
                                                                        key={data.key}
                                                                        className="ml-0"
                                                                        label={data.label}
                                                                        checked={formData.safetyConcerns.includes(
                                                                            data.id
                                                                        )}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange1(e, "safetyConcerns")
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="safety-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about suicidal thoughts :
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="safety-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["SUBSTANCE USE DIFFICULTIES"] && <div
                                                className="col-md-6 col-lg-6 mb-4"
                                                id="substanceUseDifficulty"
                                            >
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            SUBSTANCE USE DIFFICULTIES
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Are any of these substances causing you
                                                                difficulty?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="substanceUseDifficultyRadio"
                                                                    id="substance-yes"
                                                                    value="FR_14-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="substance-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="substanceUseDifficultyRadio"
                                                                    id="substance-no"
                                                                    value="FR_14-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="substance-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_14 d-none">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="ml-4 mb-2">
                                                                <div className="row">
                                                                    <div className="col-md-6 mb-0">
                                                                        {substanceUseDifficulty
                                                                            .slice(0, 6)
                                                                            .map((data) => (
                                                                                <Checkbox
                                                                                    id={data.id}
                                                                                    key={data.key}
                                                                                    className="ml-0"
                                                                                    label={data.label}
                                                                                    checked={formData.substanceUseDifficulty.includes(
                                                                                        data.id
                                                                                    )}
                                                                                    onChange={(e) =>
                                                                                        handleCheckboxChange1(
                                                                                            e,
                                                                                            "substanceUseDifficulty"
                                                                                        )
                                                                                    }
                                                                                />
                                                                            ))}
                                                                    </div>
                                                                    <div className="col-md-6 mb-0">
                                                                        {substanceUseDifficulty
                                                                            .slice(6)
                                                                            .map((data) => (
                                                                                <Checkbox
                                                                                    id={data.id}
                                                                                    key={data.key}
                                                                                    className="ml-0"
                                                                                    label={data.label}
                                                                                    checked={formData.substanceUseDifficulty.includes(
                                                                                        data.id
                                                                                    )}
                                                                                    onChange={(e) =>
                                                                                        handleCheckboxChange1(
                                                                                            e,
                                                                                            "substanceUseDifficulty"
                                                                                        )
                                                                                    }
                                                                                />
                                                                            ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="substance-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about substance use
                                                                    symptoms:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="substance-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["NEUROCOGNITIVE SYMPTOMS"] && <div
                                                className="col-md-6 col-lg-6 mb-4"
                                                id="neurocognitiveSymtpons"
                                            >
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            NEUROCOGNITIVE SYMPTOMS
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Have you had difficulty with your cognitive
                                                                abilities lately?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="neurocognitiveSymtponsRadio"
                                                                    id="cognitive-yes"
                                                                    value="FR_15-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="cognitive-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="neurocognitiveSymtponsRadio"
                                                                    id="cognitive-no"
                                                                    value="FR_15-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="cognitive-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_15 d-none">
                                                            <label className="form-label">
                                                                If you answered yes to the above question, please
                                                                provide more details:
                                                            </label>
                                                            <div className="ml-4 mb-3">
                                                                {neurocognitiveSymtpons.map((data) => (
                                                                    <Checkbox
                                                                        id={data.id}
                                                                        key={data.key}
                                                                        className="ml-0"
                                                                        label={data.label}
                                                                        checked={formData.neurocognitiveSymtpons.includes(
                                                                            data.id
                                                                        )}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange1(
                                                                                e,
                                                                                "neurocognitiveSymtpons"
                                                                            )
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>

                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="cognitive-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about cognitive abilities
                                                                    symptoms:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="cognitive-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["Past History"] && <div
                                                className="col-md-12 col-lg-12 mb-3 mb-4"
                                                id="pastHistoryOptions"
                                            >
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            Past History <br />
                                                            EARLY DEVELOPMENT
                                                        </h5>
                                                        <div className="ml-4 mb-2">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                To the best of your ability, please indicate if
                                                                you had any complicationsin your early development
                                                                :
                                                            </label>
                                                            <div className="row">
                                                                <div className="col-md-6 mb-0">
                                                                    {pastHistoryOptions.slice(0, 6).map((data) => (
                                                                        <Checkbox
                                                                            id={data.id}
                                                                            key={data.key}
                                                                            className="ml-0"
                                                                            label={data.label}
                                                                            checked={formData.pastHistoryOptions.includes(
                                                                                data.id
                                                                            )}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(
                                                                                    e,
                                                                                    "pastHistoryOptions"
                                                                                )
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                                <div className="col-md-6 mb-0">
                                                                    {pastHistoryOptions.slice(6).map((data) => (
                                                                        <Checkbox
                                                                            id={data.id}
                                                                            key={data.key}
                                                                            className="ml-0"
                                                                            label={data.label}
                                                                            checked={formData.pastHistoryOptions.includes(
                                                                                data.id
                                                                            )}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(
                                                                                    e,
                                                                                    "pastHistoryOptions"
                                                                                )
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label
                                                                htmlFor="past-history-comments"
                                                                className="form-label"
                                                            >
                                                                Additional comments about early development :
                                                            </label>
                                                            <textarea
                                                                className="form-control"
                                                                id="past-history-comments"
                                                                onChange={handleTextAreaChange}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["MENTAL HEALTH HISTORY"] && <div className="col-md-6 col-lg-6 mb-4" id="mentalHistoryOption">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            MENTAL HEALTH HISTORY
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Have you had any previous history of mental health
                                                                concerns?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="mentalHistoryOptionRadio"
                                                                    id="mental-health-yes"
                                                                    value="FR_16-yes"
                                                                    onChange={handleMainRadioChangeForTextArea}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="mental-health-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="mentalHistoryOptionRadio"
                                                                    id="mental-health-no"
                                                                    value="FR_16-no"
                                                                    onChange={handleMainRadioChangeForTextArea}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="mental-health-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_16 d-none">
                                                            <div className="ml-4 mb-2">
                                                                <label className="form-label">
                                                                    If you answered yes above, please provide
                                                                    details about your pastexperience: (Include
                                                                    Symptoms, Dates, Treatment, Outcome and
                                                                    anyadditional comments)
                                                                </label>
                                                                <div className="row">
                                                                    <div className="col-12 mb-0">
                                                                        <div className="form-check">
                                                                            {/* <input
                                                                            className="form-control"
                                                                            type="text"
                                                                            id="mental-health-depressive-episodes"
                                                                        /> */}
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="mental-health-depressive-episodes"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "mentalHistoryOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="mental-health-depressive-episodes"
                                                                            >
                                                                                Depressive episodes
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="mental-health-manic-episodes"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "mentalHistoryOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="mental-health-manic-episodes"
                                                                            >
                                                                                Manic episodes
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="mental-health-psychotic-episodes"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "mentalHistoryOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="mental-health-psychotic-episodes"
                                                                            >
                                                                                Psychotic episodes
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="mental-health-self-injurious"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "mentalHistoryOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="mental-health-self-injurious"
                                                                            >
                                                                                Self-injurious behavior
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="mental-health-anxiety"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "mentalHistoryOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="mental-health-anxiety"
                                                                            >
                                                                                Anxiety
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="mental-health-eating-issues"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "mentalHistoryOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="mental-health-eating-issues"
                                                                            >
                                                                                Eating issues
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="mental-health-trauma-issues"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "mentalHistoryOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="mental-health-trauma-issues"
                                                                            >
                                                                                Trauma-related issues
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="mental-health-relationship-issues"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "mentalHistoryOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="mental-health-relationship-issues"
                                                                            >
                                                                                Relationship issues
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="mental-health-other-issues"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "mentalHistoryOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="mental-health-other-issues"
                                                                            >
                                                                                Other issues
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="past-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about past symptom history:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="past-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["PAST PSYCHOTHERAPEUTIC TREATMENT"] && <div
                                                className="col-md-6 col-lg-6 mb-4"
                                                id="psychotherapeuticTreatment"
                                            >
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            PAST PSYCHOTHERAPEUTIC TREATMENT HISTORY
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Have you undergone any mental health treatment?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="psychotherapeuticTreatmentRadio"
                                                                    id="psychotherapeutic-yes"
                                                                    value="FR_17-yes"
                                                                    onChange={handleMainRadioChangeForTextArea}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="psychotherapeutic-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="psychotherapeuticTreatmentRadio"
                                                                    id="psychotherapeutic-no"
                                                                    value="FR_17-no"
                                                                    onChange={handleMainRadioChangeForTextArea}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="psychotherapeutic-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_17 d-none">
                                                            <div className="ml-4 mb-2">
                                                                <label className="form-label">
                                                                    If you answered yes above, please provide
                                                                    details: (Include Dates, Outcomes, and any
                                                                    additional comments)
                                                                </label>
                                                                <div className="row">
                                                                    <div className="col-12 mb-0">
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="treatment-individual-psychotherapy"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "psychotherapeuticTreatment"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="treatment-individual-psychotherapy"
                                                                            >
                                                                                Individual psychotherapy
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="treatment-family-psychotherapy"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "psychotherapeuticTreatment"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="treatment-family-psychotherapy"
                                                                            >
                                                                                Family psychotherapy
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="treatment-group-psychotherapy"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "psychotherapeuticTreatment"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="treatment-group-psychotherapy"
                                                                            >
                                                                                Group psychotherapy
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="treatment-social-skills"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "psychotherapeuticTreatment"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="treatment-social-skills"
                                                                            >
                                                                                Social skills
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="treatment-anger-management"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "psychotherapeuticTreatment"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="treatment-anger-management"
                                                                            >
                                                                                Anger management
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="treatment-intensive-outpatient"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "psychotherapeuticTreatment"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="treatment-intensive-outpatient"
                                                                            >
                                                                                Intensive outpatient
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="treatment-partial-hospitalization"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "psychotherapeuticTreatment"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="treatment-partial-hospitalization"
                                                                            >
                                                                                Partial hospitalization
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="treatment-hospitalization"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "psychotherapeuticTreatment"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="treatment-hospitalization"
                                                                            >
                                                                                Hospitalization
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="treatment-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about past psychotherapeutic
                                                                    treatment:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="treatment-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["PAST PSYCHIATRIC TREATMENT"] && <div className="col-12 mb-4" id="otcMedicationOption">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            PAST PSYCHIATRIC TREATMENT HISTORY
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                In the past, have you been on any prescribed,
                                                                herbal, alternative or over-the-counter (OTC)
                                                                medications?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="otcMedicationOptionRadio"
                                                                    id="psychiatric-treatment-yes"
                                                                    value="FR_18-yes"
                                                                    onChange={handleMainRadioChangeForTextArea}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="psychiatric-treatment-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="otcMedicationOptionRadio"
                                                                    id="psychiatric-treatment-no"
                                                                    value="FR_18-no"
                                                                    onChange={handleMainRadioChangeForTextArea}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="psychiatric-treatment-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_18 d-none">
                                                            <div className="ml-4 mb-2">
                                                                <label className="form-label">
                                                                    If you answered yes above, please provide
                                                                    details about your past treatment history:
                                                                    (Include Name, Dose, Dates, Outcome and any
                                                                    additional comments)
                                                                </label>
                                                                <div className="row">
                                                                    <div className="col-12 mb-0">
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="prescribed-med-1"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="prescribed-med-1"
                                                                            >
                                                                                Prescribed med #1
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="prescribed-med-"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="prescribed-med-2"
                                                                            >
                                                                                Prescribed med #2
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="prescribed-med-3"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="prescribed-med-3"
                                                                            >
                                                                                Prescribed med #3
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="prescribed-med-4"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="prescribed-med-4"
                                                                            >
                                                                                Prescribed med #4
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="prescribed-med-5"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="prescribed-med-5"
                                                                            >
                                                                                Prescribed med #5
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="prescribed-med-6"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="prescribed-med-6"
                                                                            >
                                                                                Prescribed med #6
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="prescribed-med-7"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="prescribed-med-7"
                                                                            >
                                                                                Prescribed med #7
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="otc-med-1"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="otc-med-1"
                                                                            >
                                                                                Over-the-counter med #1
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="otc-med-2"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="otc-med-2"
                                                                            >
                                                                                Over-the-counter med #2
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="otc-med-3"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="otc-med-3"
                                                                            >
                                                                                Over-the-counter med #3
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="herbal-med-1"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="herbal-med-1"
                                                                            >
                                                                                Herbal med #1
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="herbal-med-2"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="herbal-med-2"
                                                                            >
                                                                                Herbal med #2
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="herbal-med-3"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="herbal-med-3"
                                                                            >
                                                                                Herbal med #3
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="alternative-med-1"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="alternative-med-1"
                                                                            >
                                                                                Alternative med #1
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="alternative-med-2"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="alternative-med-2"
                                                                            >
                                                                                Alternative med #2
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="alternative-med-3"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "otcMedicationOption"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="alternative-med-3"
                                                                            >
                                                                                Alternative med #3
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="psychiatric-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about past psychiatric
                                                                    treatment:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="psychiatric-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["MEDICAL HISTORY"] && <div
                                                className="col-md-6 col-lg-6 mb-4"
                                                id="medicalHistoryOptions"
                                            >
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">MEDICAL HISTORY</h5>

                                                        <label className="form-label">
                                                            <span className="text-danger"> * </span>
                                                            Do you have, or have you had in the past, any of the
                                                            following medicalconditions?
                                                        </label>
                                                        <div className="ml-4 mb-3">
                                                            {medicalHistoryOptions.map((data) => (
                                                                <Checkbox
                                                                    id={data.id}
                                                                    key={data.key}
                                                                    className="ml-0"
                                                                    label={data.label}
                                                                    checked={formData.medicalHistoryOptions.includes(
                                                                        data.id
                                                                    )}
                                                                    onChange={(e) =>
                                                                        handleCheckboxChange1(
                                                                            e,
                                                                            "medicalHistoryOptions"
                                                                        )
                                                                    }
                                                                />
                                                            ))}
                                                        </div>

                                                        <div className="mb-3">
                                                            <label
                                                                htmlFor="medical-history-comments"
                                                                className="form-label"
                                                            >
                                                                Additional comments about medical history :
                                                            </label>
                                                            <textarea
                                                                className="form-control"
                                                                id="medical-history-comments"
                                                                onChange={handleTextAreaChange}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["NEUROLOGIC HISTORY"] && <div
                                                className="col-md-6 col-lg-6 mb-4"
                                                id="neurologicHistoryOptions"
                                            >
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            NEUROLOGIC HISTORY
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Do you have, or have you had in the past, any of
                                                                the followingneurological conditions?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="neurologicHistoryOptionsRadio"
                                                                    id="neurologic-history-yes"
                                                                    value="FR_19-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="neurologic-history-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="neurologicHistoryOptionsRadio"
                                                                    id="neurologic-history-no"
                                                                    value="FR_19-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="neurologic-history-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_19 d-none">
                                                            <label className="form-label">
                                                                Do you have, or have you had in the past, any of
                                                                the following neurologic conditions?
                                                            </label>
                                                            <div className="ml-4 mb-3">
                                                                {neurologicHistoryOptions.map((data) => (
                                                                    <Checkbox
                                                                        id={data.id}
                                                                        key={data.key}
                                                                        className="ml-0"
                                                                        label={data.label}
                                                                        checked={formData.neurologicHistoryOptions.includes(
                                                                            data.id
                                                                        )}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange1(
                                                                                e,
                                                                                "neurologicHistoryOptions"
                                                                            )
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>

                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="neurologic-history-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about neurologic history:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="neurologic-history-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {/* {enableForms && enableForms["BIRTH CONTROL"] && <div
                                                className="col-md-12 col-lg-12 mb-4"
                                                id="birthControlOptions"
                                            >
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">BIRTH CONTROL</h5>

                                                        <label className="form-label">
                                                            <span className="text-danger"> * </span>
                                                            If you are sexually active, are you or your partner
                                                            using any birth control?
                                                        </label>
                                                        <div className="ml-4 mb-3">
                                                            {birthControlOptions.map((data) => (
                                                                <Checkbox
                                                                    id={data.id}
                                                                    key={data.key}
                                                                    className="ml-0"
                                                                    label={data.label}
                                                                    checked={formData.birthControlOptions.includes(
                                                                        data.id
                                                                    )}
                                                                    onChange={(e) =>
                                                                        handleCheckboxChange1(
                                                                            e,
                                                                            "birthControlOptions"
                                                                        )
                                                                    }
                                                                />
                                                            ))}
                                                        </div>

                                                        <div className="mb-3">
                                                            <label
                                                                htmlFor="birth-control-comments"
                                                                className="form-label"
                                                            >
                                                                Additional comments about birth control:
                                                            </label>
                                                            <textarea
                                                                className="form-control"
                                                                id="birth-control-comments"
                                                                onChange={handleTextAreaChange}
                                                            ></textarea>
                                                        </div>
                                                        <h5 className="text-center mb-4">MEDICATIONS</h5>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="mb-3" id="medications">
                                                                    <label className="form-label">
                                                                        <span className="text-danger"> * </span>
                                                                        Are you currently taking any prescribed,
                                                                        herbal, alternative or over thecounter (OTC)
                                                                        medications?
                                                                    </label>
                                                                    <div className="form-check ml-4">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="alternative-otc-abilities"
                                                                            id="alternative-otc-yes"
                                                                            value="FR_20-yes"
                                                                            onChange={handleMainRadioChange}
                                                                        />
                                                                        <label
                                                                            className="form-label"
                                                                            htmlFor="alternative-otc-yes"
                                                                        >
                                                                            Yes
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check ml-4">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="alternative-otc-abilities"
                                                                            id="alternative-otc-no"
                                                                            value="FR_20-no"
                                                                            onChange={handleMainRadioChange}
                                                                        />
                                                                        <label
                                                                            className="form-label"
                                                                            htmlFor="alternative-otc-no"
                                                                        >
                                                                            No
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="FR_20 d-none mb-3">
                                                                    <label
                                                                        htmlFor="alternative-otc-comments"
                                                                        className="form-label"
                                                                    >
                                                                        If you answered yes above, please provide
                                                                        details about your currentmedications:
                                                                        (Include Medication Name, Dose, Effectiveness,
                                                                        SideEffects, and any other additional
                                                                        Comment).
                                                                    </label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        id="alternative-otc-comments"
                                                                        onChange={handleTextAreaChange}
                                                                    ></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        <span className="text-danger"> * </span>
                                                                        Do you have any allergies to medications?
                                                                    </label>
                                                                    <div className="form-check ml-4">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="medicationsRadio"
                                                                            value="FR_30-yes"
                                                                            id="alternative-otc-allergies-yes"
                                                                            onChange={handleMainRadioChange}
                                                                        />
                                                                        <label
                                                                            className="form-label"
                                                                            htmlFor="alternative-otc-allergies-yes"
                                                                        >
                                                                            Yes
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check ml-4">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="medicationsRadio"
                                                                            value="FR_30-no"
                                                                            id="alternative-otc-allergies-no"
                                                                            onChange={handleMainRadioChange}
                                                                        />
                                                                        <label
                                                                            className="form-label"
                                                                            htmlFor="alternative-otc-allergies-no"
                                                                        >
                                                                            No
                                                                        </label>
                                                                    </div>
                                                                    <div className="FR_30 d-none">
                                                                        <div className="mb-3">
                                                                            <label
                                                                                htmlFor="anxiety-comments"
                                                                                className="form-label"
                                                                            >
                                                                                Please provide more details on allergies to medications.
                                                                            </label>
                                                                            <textarea
                                                                                onChange={handleTextAreaChange}
                                                                                className="form-control"
                                                                                id="anxiety-comments"
                                                                            ></textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>} */}
                                            {enableForms && enableForms["FAMILY PSYCHIATRIC HISTORY"] && <div
                                                className="col-md-6 col-lg-6 mb-4"
                                                id="familyHistoryOptions"
                                            >
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            FAMILY PSYCHIATRIC HISTORY
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Is there any family history of mental health
                                                                issues?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="familyHistoryOptionsRadio"
                                                                    id="family-history-yes"
                                                                    value="FR_21-yes"
                                                                    onChange={handleMainRadioChangeForTextArea}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="family-history-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="familyHistoryOptionsRadio"
                                                                    id="family-history-no"
                                                                    value="FR_21-no"
                                                                    onChange={handleMainRadioChangeForTextArea}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="family-history-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_21 d-none">
                                                            <div className="ml-4 mb-2">
                                                                <label className="form-label">
                                                                    If you answered yes above, please provide
                                                                    details:
                                                                </label>
                                                                <div className="row">
                                                                    <div className="col-12 mb-0">
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-mother"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-mother"
                                                                            >
                                                                                Mother
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-grandmother"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-grandmother"
                                                                            >
                                                                                Grandmother
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-grandfather"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-grandfather"
                                                                            >
                                                                                Grandfather
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-uncle"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-uncle"
                                                                            >
                                                                                Uncle
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-aunt"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-aunt"
                                                                            >
                                                                                Aunt
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-cousin"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-cousin"
                                                                            >
                                                                                Cousin
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-father"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-father"
                                                                            >
                                                                                Father
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-sister"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-sister"
                                                                            >
                                                                                Sister
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-brother"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-brother"
                                                                            >
                                                                                Brother
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-daughter"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-daughter"
                                                                            >
                                                                                Daughter
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-history-son"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyHistoryOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-history-son"
                                                                            >
                                                                                Son
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="family-history-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about family psychiatric
                                                                    history:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="family-history-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["FAMILY MEDICAL HISTORY"] && <div
                                                className="col-md-6 col-lg-6 mb-4"
                                                id="familyMedicalOptions"
                                            >
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            FAMILY MEDICAL HISTORY
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Is there any family history of medical issues?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="familyMedicalOptionsRadio"
                                                                    id="family-medical-yes"
                                                                    value="FR_22-yes"
                                                                    onChange={handleMainRadioChangeForTextArea}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="family-medical-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="familyMedicalOptionsRadio"
                                                                    id="family-medical-no"
                                                                    value="FR_22-no"
                                                                    onChange={handleMainRadioChangeForTextArea}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="family-medical-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_22 d-none">
                                                            <div className="ml-4 mb-2">
                                                                <label className="form-label">
                                                                    If you answered yes above, please provide
                                                                    details:
                                                                </label>
                                                                <div className="row">
                                                                    <div className="col-12 mb-0">
                                                                        <div className="form-group">
                                                                            {/* <input
                                                                            className="form-control"
                                                                            type="text"
                                                                            id="family-medical-mother"
                                                                        /> */}
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-mother"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-mother"
                                                                            >
                                                                                Mother
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-grandmother"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-grandmother"
                                                                            >
                                                                                Grandmother
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-grandfather"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-grandfather"
                                                                            >
                                                                                Grandfather
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-uncle"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-uncle"
                                                                            >
                                                                                Uncle
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-aunt"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-aunt"
                                                                            >
                                                                                Aunt
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-cousin"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-cousin"
                                                                            >
                                                                                Cousin
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-father"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-father"
                                                                            >
                                                                                Father
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-sister"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-sister"
                                                                            >
                                                                                Sister
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-brother"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-brother"
                                                                            >
                                                                                Brother
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-daughter"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-daughter"
                                                                            >
                                                                                Daughter
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="family-medical-son"
                                                                                onChange={(e) =>
                                                                                    handleTextAreaChange2(
                                                                                        e,
                                                                                        "familyMedicalOptions"
                                                                                    )
                                                                                }
                                                                            ></textarea>
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor="family-medical-son"
                                                                            >
                                                                                Son
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor="family-medical-comments"
                                                                    className="form-label"
                                                                >
                                                                    Additional comments about family psychiatric
                                                                    history:
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="family-medical-comments"
                                                                    onChange={handleTextAreaChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["EDUCATION/WORK HISTORY"] && <div className="col-md-6 col-lg-6 mb-4" id="academicExperience">
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">
                                                            EDUCATION/WORK HISTORY
                                                        </h5>
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                <span className="text-danger"> * </span>
                                                                Is there any notable academic history?
                                                            </label>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="academicExperienceRadio"
                                                                    id="educational-history-yes"
                                                                    value="FR_23-yes"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="educational-history-yes"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check ml-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="academicExperienceRadio"
                                                                    id="educational-history-no"
                                                                    value="FR_23-no"
                                                                    onChange={handleMainRadioChange}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="educational-history-no"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="FR_23 d-none">
                                                            <div className="mb-3">
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="educational-history-1"
                                                                >
                                                                    If you answered yes above, please provide more
                                                                    details about academic history :
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    type="text"
                                                                    id="educational-history-1"
                                                                    onChange={handleTextAreaChange}
                                                                />
                                                            </div>
                                                            <div className=" mb-2">
                                                                <label className="form-label">
                                                                    Were there any learning issues?
                                                                </label>
                                                                <div
                                                                    className="ml-4 mb-3"
                                                                    id="academicPerformance"
                                                                >
                                                                    <div className="form-group">
                                                                        {academicPerformanceOptions.map((data) => (
                                                                            <RadioButton
                                                                                id={data.id}
                                                                                key={data.id}
                                                                                label={data.label}
                                                                                // className="ml-0"
                                                                                name="academicPerformance"
                                                                                checked={
                                                                                    formData.academicPerformance == data.id
                                                                                }
                                                                                onChange={(e) =>
                                                                                    handleRadioChange(
                                                                                        e,
                                                                                        "academicPerformance"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="mb-3"
                                                                    id="academicExperienceOptions"
                                                                >
                                                                    <label className="form-label">
                                                                        How was your overall academic experience?
                                                                    </label>
                                                                    <div className="ml-4">
                                                                        {academicExperienceOptions.map((data) => (
                                                                            <RadioButton
                                                                                id={data.id}
                                                                                key={data.id}
                                                                                // name={data.name}
                                                                                name="academicExperienceOptions"
                                                                                label={data.label}
                                                                                checked={
                                                                                    formData.academicExperienceOptions ==
                                                                                    data.id
                                                                                }
                                                                                onChange={(e) =>
                                                                                    handleRadioChange(
                                                                                        e,
                                                                                        "academicExperienceOptions"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3" id="academicIntervention">
                                                                    <label className="form-label">
                                                                        Were there any academic interventions ?
                                                                    </label>
                                                                    <div className="ml-4">
                                                                        {academicInterventionOptions.map((data) => (
                                                                            <Checkbox
                                                                                id={data.id}
                                                                                key={data.id}
                                                                                label={data.label}
                                                                                checked={formData.academicIntervention.includes(
                                                                                    data.id
                                                                                )}
                                                                                onChange={(e) =>
                                                                                    handleCheckboxChange1(
                                                                                        e,
                                                                                        "academicIntervention"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <label
                                                                        htmlFor="educational-history-comments"
                                                                        className="form-label"
                                                                    >
                                                                        Additional comments about educational history
                                                                        :
                                                                    </label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        id="educational-history-comments"
                                                                        onChange={handleTextAreaChange}
                                                                    ></textarea>
                                                                </div>
                                                                <div className="mb-3" id="workPerformanceOptions">
                                                                    <label className="form-label">
                                                                        How is your work performance?
                                                                    </label>
                                                                    <div className="ml-4">
                                                                        {workPerformanceOptions.map((data) => (
                                                                            <RadioButton
                                                                                id={data.id}
                                                                                key={data.id}
                                                                                label={data.label}
                                                                                // className="ml-0"
                                                                                name="workPerformanceOptions"
                                                                                checked={
                                                                                    formData.workPerformanceOptions ==
                                                                                    data.id
                                                                                }
                                                                                onChange={(e) =>
                                                                                    handleRadioChange(
                                                                                        e,
                                                                                        "workPerformanceOptions"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3" id="workExperienceOptions">
                                                                    <label className="form-label">
                                                                        How is your overall work experience?
                                                                    </label>
                                                                    <div className="ml-4">
                                                                        {workExperienceOptions.map((data) => (
                                                                            <RadioButton
                                                                                id={data.id}
                                                                                key={data.id}
                                                                                label={data.label}
                                                                                // className="ml-0"
                                                                                name="workExperienceOptions"
                                                                                checked={
                                                                                    formData.workExperienceOptions ==
                                                                                    data.id
                                                                                }
                                                                                onChange={(e) =>
                                                                                    handleRadioChange(
                                                                                        e,
                                                                                        "workExperienceOptions"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <label
                                                                        htmlFor="work-history-comments"
                                                                        className="form-label"
                                                                    >
                                                                        Additional comments about work history :
                                                                    </label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        id="work-history-comments"
                                                                        onChange={handleTextAreaChange}
                                                                    ></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {enableForms && enableForms["SOCIAL HISTORY"] && <div
                                                className="col-md-6 col-lg-6 mb-4"
                                                id="familyRelationshipOptions1"
                                            >
                                                <div className="card h-100">
                                                    <div className="card-body">
                                                        <h5 className="text-center mb-4">SOCIAL HISTORY</h5>
                                                        <div className="row">
                                                            <div className="col-md-12 col-lg-12">
                                                                <label className="form-label">
                                                                    <span className="text-danger"> * </span>
                                                                    How would you describe your family
                                                                    relationships?
                                                                </label>
                                                                <div className="ml-4 mb-3">
                                                                    {familyRelationshipOptions.map((data) => (
                                                                        <Checkbox
                                                                            key={data.id}
                                                                            id={data.id}
                                                                            label={data.label}
                                                                            checked={formData.familyRelationshipOptions1.includes(
                                                                                data.id
                                                                            )}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(
                                                                                    e,
                                                                                    "familyRelationshipOptions1"
                                                                                )
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                                <div
                                                                    className="mb-3"
                                                                    id="socialRelationshipOptions"
                                                                >
                                                                    <label className="form-label">
                                                                        How would you describe your social
                                                                        relationships?
                                                                    </label>
                                                                    <div className="ml-4">
                                                                        {socialRelationshipOptions.map((data) => (
                                                                            <Checkbox
                                                                                key={data.id}
                                                                                id={data.id}
                                                                                label={data.label}
                                                                                checked={formData.socialRelationshipOptions.includes(
                                                                                    data.id
                                                                                )}
                                                                                onChange={(e) =>
                                                                                    handleCheckboxChange1(
                                                                                        e,
                                                                                        "socialRelationshipOptions"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                {/* <div className="mb-3" id="gender">
                                                                <label className="form-label">
                                                                    How do you feel about your gender?
                                                                </label>
                                                                <div className="ml-4">
                                                                    {gender.map((data) => (
                                                                        <Checkbox
                                                                            key={data.id}
                                                                            id={data.id}
                                                                            label={data.label}
                                                                            checked={formData.gender.includes(
                                                                                data.id
                                                                            )}
                                                                            onChange={(e) =>
                                                                                handleCheckboxChange1(e, "gender")
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div> */}
                                                                {/* <div className="mb-3" id="satisfactionSex">
                                                                    <label className="form-label">
                                                                        How would you describe your satisfaction from
                                                                        sex?
                                                                    </label>
                                                                    <div className="ml-4">
                                                                        {satisfactionSex.map((data) => (
                                                                            <Checkbox
                                                                                key={data.id}
                                                                                id={data.id}
                                                                                label={data.label}
                                                                                checked={formData.satisfactionSex.includes(
                                                                                    data.id
                                                                                )}
                                                                                onChange={(e) =>
                                                                                    handleCheckboxChange1(
                                                                                        e,
                                                                                        "satisfactionSex"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div> */}
                                                                <div className="mb-3" id="interest">
                                                                    <label className="form-label">
                                                                        What are your interests?
                                                                    </label>
                                                                    <div className="ml-4">
                                                                        {interest.map((data) => (
                                                                            <Checkbox
                                                                                key={data.id}
                                                                                id={data.id}
                                                                                label={data.label}
                                                                                checked={formData.interest.includes(
                                                                                    data.id
                                                                                )}
                                                                                onChange={(e) =>
                                                                                    handleCheckboxChange1(e, "interest")
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3" id="livingSituations">
                                                                    <label className="form-label">
                                                                        What is your current living situation?
                                                                    </label>
                                                                    <div className="ml-4">
                                                                        {livingSituations.map((data) => (
                                                                            <RadioButton
                                                                                id={data.id}
                                                                                key={data.id}
                                                                                // name={data.name}
                                                                                name="livingSituations"
                                                                                label={data.label}
                                                                                checked={
                                                                                    formData.livingSituations == data.id
                                                                                }
                                                                                onChange={(e) =>
                                                                                    handleRadioChange(e, "livingSituations")
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3" id="workEducationOptions">
                                                                    <label className="form-label">
                                                                        What is your current work/education situation?
                                                                    </label>
                                                                    <div className="ml-4">
                                                                        {workEducationOptions.map((data) => (
                                                                            <RadioButton
                                                                                id={data.id}
                                                                                key={data.id}
                                                                                // name={data.name}
                                                                                name="workEducationOptions"
                                                                                label={data.label}
                                                                                checked={
                                                                                    formData.workEducationOptions == data.id
                                                                                }
                                                                                onChange={(e) =>
                                                                                    handleRadioChange(
                                                                                        e,
                                                                                        "workEducationOptions"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="mb-3"
                                                                    id="relationshipStatusOptions"
                                                                >
                                                                    <label className="form-label">
                                                                        What is your current relationship status?
                                                                    </label>
                                                                    <div className="ml-4">
                                                                        {relationshipStatusOptions.map((data) => (
                                                                            <RadioButton
                                                                                id={data.id}
                                                                                key={data.id}
                                                                                // name={data.name}
                                                                                name="relationshipStatusOptions"
                                                                                label={data.label}
                                                                                checked={
                                                                                    formData.relationshipStatusOptions ==
                                                                                    data.id
                                                                                }
                                                                                onChange={(e) =>
                                                                                    handleRadioChange(
                                                                                        e,
                                                                                        "relationshipStatusOptions"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label
                                                                htmlFor="social-history-comments"
                                                                className="form-label"
                                                            >
                                                                Additional comments about social history:
                                                            </label>
                                                            <textarea
                                                                className="form-control"
                                                                id="social-history-comments"
                                                                onChange={handleTextAreaChange}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                    </form>
                                </div>
                                {/* <embed src={pdf2} type="application/pdf" width="100%" height="800px" /> */}
                            </div>
                        )}

                    {
                     
                            currentStep == 2 && (
                                <div className="step last_form d-block">
                                    {/*  <embed src={pdf1} type="application/pdf" width="100%" height="800px" />  */}
                                    <div className="container question-container mt-5">
                                        <div className="d-flex justify-content-center">
                                            <h5 className="mb-4">
                                                Patient Health Questionnaire and General Anxiety Disorder
                                            </h5>
                                            <br />
                                        </div>
                                        <h5 className="d-flex justify-content-center mb-5">
                                            (PHQ-9 and GAD-7)
                                        </h5>

                                        <form>
                                            <div className="row mb-3">
                                                <div className="col-md-4">
                                                    <label htmlFor="date" className="form-label">
                                                        Date
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={date}
                                                        disabled
                                                        id="date"
                                                        required=""

                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="patientName" className="form-label">
                                                        Patient Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="patientName"
                                                        value={name}

                                                        disabled
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="dob" className="form-label ">
                                                        Date of Birth
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="dob"
                                                        value={dob}
                                                        disabled

                                                    />
                                                </div>
                                            </div>
                                            <h2 className="mt-4"></h2>
                                            <p>
                                                Over the last 2 weeks, how often have you been bothered by
                                                any of the following problems?
                                            </p>
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="">
                                                                <h5>PHQ-9</h5>
                                                            </th>
                                                            <th
                                                                className="text-center"
                                                                style={{ minWidth: "70px" }}
                                                            >
                                                                Not at all <br /> (0)
                                                            </th>
                                                            <th
                                                                className="text-center"
                                                                style={{ minWidth: "70px" }}
                                                            >
                                                                Several days <br /> (1)
                                                            </th>
                                                            <th
                                                                className="text-center"
                                                                style={{ minWidth: "70px" }}
                                                            >
                                                                More than half the days <br /> (2)
                                                            </th>
                                                            <th
                                                                className="text-center"
                                                                style={{ minWidth: "70px" }}
                                                            >
                                                                Nearly every day <br /> (3)
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* {phqQuestions.map((question) => (
                                                    <tr key={question.id}>
                                                        <td
                                                            className={
                                                                question.id == "10" || question.id == "11"
                                                                    ? "text-center"
                                                                    : ""
                                                            }
                                                        >
                                                            {question.id == "10" || question.id == "11"
                                                                ? ""
                                                                : question.id + ". "}{" "}
                                                            {question.text}
                                                        </td>
                                                        {question.id == 10 ? (
                                                            <>
                                                                {columnCounts.map((count, index) => (
                                                                    <td key={index} className="text-center">
                                                                        <input
                                                                            className="form-control text-center"
                                                                            type="number"
                                                                            value={count}
                                                                            readOnly
                                                                        />
                                                                    </td>
                                                                ))}
                                                            </>
                                                        ) : question.id == 11 ? (
                                                            <td className="text-center" colSpan={4}>
                                                                <input
                                                                    className="form-control text-center"
                                                                    type="number"
                                                                    name={question.name}
                                                                    value={10}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        ) : (
                                                            [0, 1, 2, 3].map((value) => (
                                                                <td
                                                                    className="text-center align-middle"
                                                                    key={value}
                                                                >
                                                                    <input
                                                                        className="form-input"
                                                                        type="checkbox"
                                                                        name={question.name}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange(
                                                                                value,
                                                                                e.target.checked
                                                                            )
                                                                        }

                                                                    />
                                                                </td>
                                                            ))
                                                        )}
                                                    </tr>
                                                ))} //12-16-2024 */}
                                                        {phqQuestions.map((question) => (
                                                            <tr key={question.id}>
                                                                <td
                                                                    className={question.id == "10" || question.id == "11" ? "text-center" : ""}
                                                                >
                                                                    {question.id == "10" || question.id == "11"
                                                                        ? ""
                                                                        : question.id + ". "}
                                                                    {question.text}
                                                                </td>

                                                                {question.id == 10 ? (
                                                                    <>
                                                                        {columnCounts.map((count, index) => (
                                                                            <td key={index} className="text-center">
                                                                                <input
                                                                                    className="form-control text-center"
                                                                                    type="number"
                                                                                    value={count} // Display the column total value
                                                                                    data-question="10"
                                                                                    data-column={index}
                                                                                    readOnly
                                                                                />
                                                                            </td>
                                                                        ))}
                                                                    </>
                                                                ) : question.id == 11 ? (
                                                                    <td className="text-center" colSpan={4}>
                                                                        <input
                                                                            className="form-control text-center"
                                                                            type="number"
                                                                            name={question.name}
                                                                            id="question_11"
                                                                            value={calculateTotalScore()} // Function to calculate the total score for all questions
                                                                            readOnly
                                                                        />
                                                                    </td>
                                                                ) : (
                                                                    [0, 1, 2, 3].map((value) => (
                                                                        <td className="text-center align-middle" key={value}>
                                                                            <input
                                                                                className="form-input"
                                                                                type="checkbox"
                                                                                name={`question_${question.id}`}
                                                                                checked={scores[question.id] === value} // Ensure it reflects only the selected value
                                                                                onChange={(e) => handleCheckboxChange(question.id, value, e.target.checked)}
                                                                            />
                                                                        </td>
                                                                    ))
                                                                )}
                                                            </tr>
                                                        ))}


                                                        {/* Display the total score */}


                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="mb-5">
                                                <label
                                                    htmlFor="phq_difficulty"
                                                    className="select_diff_text mr-2"
                                                >
                                                    If you checked off any problems, how difficult have these
                                                    made it for you <br /> to do your work, take care of
                                                    things at home, or get along with other people?
                                                </label>

                                                <select
                                                    className="form-control w-50 mt-2"
                                                    id="phq_difficulty"
                                                    name="phq_difficulty"
                                                    required
                                                >
                                                    <option value="">Select difficulty level</option>
                                                    <option value="Not difficult at all">
                                                        Not difficult at all
                                                    </option>
                                                    <option value="Somewhat difficult">
                                                        Somewhat difficult
                                                    </option>
                                                    <option value="Very Difficult">Very Difficult</option>
                                                    <option value="Extremely Difficult">
                                                        Extremely Difficult
                                                    </option>
                                                </select>
                                            </div>

                                            {/* <h2 className="mt-4"></h2> */}
                                            <p className="mt-4">
                                                Over the last 2 weeks, how often have you been bothered by
                                                any of the following problems?
                                            </p>
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th className="">
                                                            <h5>GAD-7</h5>
                                                        </th>
                                                        <th
                                                            className="text-center"
                                                            style={{ minWidth: "70px" }}
                                                        >
                                                            Not at all sure <br /> (0)
                                                        </th>
                                                        <th
                                                            className="text-center"
                                                            style={{ minWidth: "70px" }}
                                                        >
                                                            Several days <br /> (1)
                                                        </th>
                                                        <th
                                                            className="text-center"
                                                            style={{ minWidth: "70px" }}
                                                        >
                                                            Over half the days <br /> (2)
                                                        </th>
                                                        <th
                                                            className="text-center"
                                                            style={{ minWidth: "70px" }}
                                                        >
                                                            Nearly every day <br /> (3)
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* 12/16/2024 {gad7Questions.map((data) => (
                                                <tr key={data.id}>
                                                    <td
                                                        className={
                                                            data.id == "8" || data.id == "9"
                                                                ? "text-center"
                                                                : ""
                                                        }
                                                    >
                                                        {data.id == "8" || data.id == "9"
                                                            ? ""
                                                            : data.id + "."}{" "}
                                                        {data.text}
                                                    </td>

                                                    {data.id == "8" ? (
                                                        <>
                                                            {columnGadCounters.map((count, index) => (
                                                                <td key={index} className="text-center">
                                                                    <input
                                                                        className="form-control text-center"
                                                                        type="number"
                                                                        value={count}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            ))}
                                                        </>
                                                    ) : data.id == 9 ? (
                                                        <td className="text-center" colSpan={4}>
                                                            <input
                                                                className="form-control text-center"
                                                                type="number"
                                                                name={data.name}
                                                                value={7}
                                                                readOnly
                                                            />
                                                        </td>
                                                    ) : (
                                                        <>
                                                            {[0, 1, 2, 3].map((value) => (
                                                                <td
                                                                    className="text-center align-middle"
                                                                    key={value}
                                                                >
                                                                    <input
                                                                        className="form-input"
                                                                        type="checkbox"
                                                                        name={data.name}
                                                                        onChange={(e) =>
                                                                            handleQadCheckboxChange(
                                                                                value,
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                        value={value}

                                                                    />
                                                                </td>
                                                            ))}
                                                        </>
                                                    )}
                                                </tr>
                                            ))} */}
                                                    {gad7Questions.map((data) => (
                                                        <tr key={data.id}>
                                                            <td
                                                                className={
                                                                    data.id == "gad_8" || data.id == "gad_9"
                                                                        ? "text-center"
                                                                        : ""
                                                                }
                                                            >
                                                                {data.id == "gad_8" || data.id == "gad_9"
                                                                    ? ""
                                                                    : data.id + "."}{" "}
                                                                {data.text}
                                                            </td>

                                                            {data.id == 8 ? (
                                                                <>
                                                                    {columnGadCounters.map((count, index) => (
                                                                        <td key={index} className="text-center">
                                                                            <input
                                                                                className="form-control text-center"
                                                                                type="number"
                                                                                value={count}
                                                                                data-question-gad="8"
                                                                                data-column-gad={index}
                                                                                readOnly
                                                                            />
                                                                        </td>
                                                                    ))}
                                                                </>
                                                            ) : data.id == 9 ? (
                                                                <td className="text-center" colSpan={4}>
                                                                    <input
                                                                        className="form-control text-center"
                                                                        type="number"
                                                                        name={data.name}
                                                                        value={calculateTotalQadScore()}
                                                                        id='gad-question-total'
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            ) : (
                                                                <>
                                                                    {[0, 1, 2, 3].map((value) => (
                                                                        <td
                                                                            className="text-center align-middle"
                                                                            key={value}
                                                                        >
                                                                            <input
                                                                                className="form-input"
                                                                                type="checkbox"
                                                                                name={`gad_question_${data.id}`}
                                                                                id={data.id}
                                                                                checked={gadScores[data.id] === value} // Ensure it reflects only the selected value
                                                                                onChange={(e) => handleQadCheckboxChange(data.id, value, e.target.checked)}
                                                                            />
                                                                        </td>
                                                                    ))}

                                                                </>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            <div className="mb-5">
                                                <label
                                                    htmlFor="phq_difficulty1"
                                                    className="select_diff_text mr-2"
                                                >
                                                    If you checked off any problems, how difficult have these
                                                    made it for you <br /> to do your work, take care of
                                                    things at home, or get along with other people?
                                                </label>

                                                <select
                                                    className="form-control w-50 mt-2"
                                                    id="phq_difficulty1"
                                                    name="phq_difficulty1"
                                                    required
                                                >
                                                    <option value="">Select difficulty level</option>
                                                    <option value="Not difficult at all">
                                                        Not difficult at all
                                                    </option>
                                                    <option value="Somewhat difficult">
                                                        Somewhat difficult
                                                    </option>
                                                    <option value="Very Difficult">Very Difficult</option>
                                                    <option value="Extremely Difficult">
                                                        Extremely Difficult
                                                    </option>
                                                </select>
                                            </div>

                                            <p className="d-flex justify-content-end">UHS Rev 4/2020</p>
                                            <p className="text-center text-muted">
                                                Developed by Drs. Robert L. Spitzer, Janet B.W. Williams,
                                                Kurt Kroenke and colleagues, with an educational grant from
                                                Pfizer Inc. No permission required to reproduce, translate,
                                                display or distribute, 1999.
                                            </p>

                                            <div className="d-flex justify-content-end mt-3">
                                                <SignatureCanvas
                                                    penColor="black"
                                                    ref={sigCanvas}
                                                    canvasProps={{
                                                        width: 250,
                                                        height: 150,
                                                        className: "sigCanvas",
                                                    }}
                                                />
                                                <button
                                                    className="btn btn-outline-secondary w-5"
                                                    type="button"
                                                    onClick={clearSignature}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            )
                    }


                    <div className="col-12 mt-5">
                        <div className=" d-flex justify-content-end">
                            <button
                                id="prev-btn"
                                type="button"
                                style={{ margin: "0 auto" }}
                                className={`btn btn-primary ${currentStep === 0 ? "d-none" : ""
                                    }`}
                                onClick={handlePrev}
                            >
                                Previous
                            </button>
                            <button
                                id="nextbtn"
                                style={{ margin: "0 auto" }}
                                type="button"
                                className={`btn btn-primary ${currentStep === stepCount - 1 ? "d-none" : ""
                                    }`}
                                onClick={handleNext}
                            >
                                Next
                            </button>

                            <button
                                id="submitbtn"
                                type="button"
                                style={{ margin: "0 auto" }}
                                className={`btn btn-primary ${currentStep === stepCount - 1 ? "d-block" : "d-none"
                                    }`}
                                // data-toggle="modal"
                                // data-target="#confirmationModal"
                                onClick={handleSubmit}
                            >
                                Book An Appointment
                            </button>
                        </div>
                    </div>
                </div>
            </form>

            <div
                className="modal fade"
                id="confirmationModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="confirmationModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="confirmationModalLabel">
                                Confirm Appointment
                            </h5>
                            <button
                                type="button"
                                // className="btn-close"
                                className="close btn-close"
                                data-bs-dismiss="modal"
                                onClick={ModalCloseHandler}
                                //  onClick={() => removeLocalStorage() , navigate('')}
                                aria-label="Close"

                            ></button>
                        </div>
                        <div className="modal-body">
                            {/* <h4 className="mb-3">Privacy and Policies:</h4> */}
                            <p>Are you sure you want to submit this application?</p>
                            <p> Please review all information carefully before proceeding. Once submitted, you may not be able to make further changes.</p>
                            {/* <div className="form-check mb-2 ml-3">
                                <input
                                    className="form-check-input"
                                    checked
                                    type="checkbox"
                                    id="telehealthConsent"
                                />
                                <label className="form-check-label" htmlFor="telehealthConsent">
                                    <a
                                        href="/assets/pdf/Consent for Telehealth Consultation.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                    >
                                        Consent for Telehealth Consultation
                                    </a>
                                </label>
                            </div>
                            <div className="form-check mb-2 ml-3">
                                <input
                                    className="form-check-input"
                                    checked
                                    type="checkbox"
                                    id="privacyNotice"
                                />
                                <label className="form-check-label" htmlFor="privacyNotice">
                                    <a
                                        href="/assets/pdf/Notice of Privacy Practices.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                    >
                                        Notice of Privacy Practices
                                    </a>
                                </label>
                            </div>
                            <div className="form-check mb-2 ml-3">
                                <input
                                    className="form-check-input"
                                    checked
                                    type="checkbox"
                                    id="practicePolicies"
                                />
                                <label className="form-check-label" htmlFor="practicePolicies">
                                    <a
                                        href="/assets/pdf/Practice Policies.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                    >
                                        Practice Policies
                                    </a>
                                </label>
                            </div> */}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button
                                id="cnfbtn"
                                type="button"
                                className="btn btn-primary"
                                onClick={handleConfirmAppointment}
                            >
                                Confirm Appointment
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookAppointment;
